/* tslint:disable */
/* eslint-disable */
/**
 * 大臣 AX クラウド管理 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.10.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 * アクセスキー情報
 * @export
 * @interface AccessKeyInputModel
 */
export interface AccessKeyInputModel {
  /**
   * アクセスキー名
   * @type {string}
   * @memberof AccessKeyInputModel
   */
  name: string;
}
/**
 * アクセスキー
 * @export
 * @interface AccessKeyViewModel
 */
export interface AccessKeyViewModel {
  /**
   * アクセスキー
   * @type {string}
   * @memberof AccessKeyViewModel
   */
  id?: string | null;
  /**
   * テナント ID
   * @type {string}
   * @memberof AccessKeyViewModel
   */
  tenantId?: string | null;
  /**
   * アクセスキー名
   * @type {string}
   * @memberof AccessKeyViewModel
   */
  name?: string | null;
  /**
   * アクセスキーの値
   * @type {string}
   * @memberof AccessKeyViewModel
   */
  value?: string | null;
  /**
   * プライマリーなアクセスキーかどうか
   * @type {boolean}
   * @memberof AccessKeyViewModel
   */
  isPrimary?: boolean;
}
/**
 * アプリの詳細
 * @export
 * @interface ApplicationDetailsViewModel
 */
export interface ApplicationDetailsViewModel {
  /**
   * アプリ ID
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  id?: string | null;
  /**
   * アプリ名
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  name?: string | null;
  /**
   * 製品 ID
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  productId?: string | null;
  /**
   * アプリの説明
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  description?: string | null;
  /**
   *
   * @type {ApplicationType}
   * @memberof ApplicationDetailsViewModel
   */
  type?: ApplicationType;
  /**
   * クライアント ID
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  clientId?: string | null;
  /**
   * クライアントシークレット
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  clientSecret?: string | null;
  /**
   * ホームページ URI
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  uri?: string | null;
  /**
   * リダイレクト URI
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  redirectUri?: string | null;
  /**
   * Webhook を使用する
   * @type {boolean}
   * @memberof ApplicationDetailsViewModel
   */
  webHookEnabled?: boolean;
  /**
   * Webhook URL
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  webHookUrl?: string | null;
  /**
   * Webhook Secret
   * @type {string}
   * @memberof ApplicationDetailsViewModel
   */
  webHookSecret?: string | null;
  /**
   *
   * @type {WebHookFilterMode}
   * @memberof ApplicationDetailsViewModel
   */
  webHookFilterMode?: WebHookFilterMode;
  /**
   * アプリがハンドルする Web フックのイベント
   * @type {Array<string>}
   * @memberof ApplicationDetailsViewModel
   */
  webHookEvents?: Array<string> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApplicationType = {
  Web: "Web",
  Native: "Native",
} as const;

export type ApplicationType =
  (typeof ApplicationType)[keyof typeof ApplicationType];

/**
 * アプリ
 * @export
 * @interface ApplicationViewModel
 */
export interface ApplicationViewModel {
  /**
   * アプリ ID
   * @type {string}
   * @memberof ApplicationViewModel
   */
  id?: string | null;
  /**
   * アプリ名
   * @type {string}
   * @memberof ApplicationViewModel
   */
  name?: string | null;
}
/**
 * 解約された契約
 * @export
 * @interface CancelledContractViewModel
 */
export interface CancelledContractViewModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof CancelledContractViewModel
   */
  id?: string | null;
  /**
   * 会社名
   * @type {string}
   * @memberof CancelledContractViewModel
   */
  companyName?: string | null;
  /**
   * 利用期間開始日
   * @type {string}
   * @memberof CancelledContractViewModel
   */
  startAt?: string | null;
  /**
   * 利用期間終了日
   * @type {string}
   * @memberof CancelledContractViewModel
   */
  endAt?: string | null;
  /**
   * 解約日時
   * @type {string}
   * @memberof CancelledContractViewModel
   */
  cancelledAt?: string;
}
/**
 * パスワード変更要求
 * @export
 * @interface ChangeContractPasswordInputModel
 */
export interface ChangeContractPasswordInputModel {
  /**
   * 現在のパスワード
   * @type {string}
   * @memberof ChangeContractPasswordInputModel
   */
  currentPassword: string;
  /**
   * 新しいパスワード
   * @type {string}
   * @memberof ChangeContractPasswordInputModel
   */
  newPassword: string;
}
/**
 * 契約の詳細
 * @export
 * @interface ContractDetailsViewModel
 */
export interface ContractDetailsViewModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  contractId?: string | null;
  /**
   * 会社名
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  companyName?: string | null;
  /**
   * メールアドレス
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  email?: string | null;
  /**
   * メールアドレス(予備1)
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  subEmail1?: string | null;
  /**
   * メールアドレス(予備2)
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  subEmail2?: string | null;
  /**
   * 認証コード
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  authenticationCode?: string | null;
  /**
   * 利用開始日時
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  startAt?: string;
  /**
   * 利用終了日時
   * @type {string}
   * @memberof ContractDetailsViewModel
   */
  endAt?: string;
  /**
   *
   * @type {ContractPlatformViewModel}
   * @memberof ContractDetailsViewModel
   */
  platform?: ContractPlatformViewModel;
  /**
   * 追加データ容量
   * @type {number}
   * @memberof ContractDetailsViewModel
   */
  additionalDataCapacity?: number;
  /**
   * 追加データ領域数
   * @type {number}
   * @memberof ContractDetailsViewModel
   */
  additionalDataAreaCount?: number;
  /**
   * 無償体験
   * @type {boolean}
   * @memberof ContractDetailsViewModel
   */
  trial?: boolean | null;
  /**
   * 契約製品の一覧
   * @type {Array<ContractProductDetailsViewModel>}
   * @memberof ContractDetailsViewModel
   */
  products?: Array<ContractProductDetailsViewModel> | null;
}
/**
 * 登録する操作ログ
 * @export
 * @interface ContractLogInputModel
 */
export interface ContractLogInputModel {
  /**
   * 操作
   * @type {string}
   * @memberof ContractLogInputModel
   */
  action: string;
}
/**
 * 操作ログ
 * @export
 * @interface ContractLogViewModel
 */
export interface ContractLogViewModel {
  /**
   * ID
   * @type {string}
   * @memberof ContractLogViewModel
   */
  id?: string | null;
  /**
   * 日時
   * @type {string}
   * @memberof ContractLogViewModel
   */
  loggedAt?: string;
  /**
   * IP アドレス
   * @type {string}
   * @memberof ContractLogViewModel
   */
  ipAddress?: string | null;
  /**
   * 操作
   * @type {string}
   * @memberof ContractLogViewModel
   */
  action?: string | null;
}
/**
 * 二要素認証ログインのインプットモデル
 * @export
 * @interface ContractLogin2faInputModel
 */
export interface ContractLogin2faInputModel {
  /**
   * 認証コード
   * @type {string}
   * @memberof ContractLogin2faInputModel
   */
  authenticationCode?: string | null;
}
/**
 * 契約ログインの入力
 * @export
 * @interface ContractLoginInputModel
 */
export interface ContractLoginInputModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof ContractLoginInputModel
   */
  contractId: string;
  /**
   * パスワード
   * @type {string}
   * @memberof ContractLoginInputModel
   */
  password: string;
}
/**
 * リカバリーコードログインのインプットモデル
 * @export
 * @interface ContractLoginRecoveryCodeInputModel
 */
export interface ContractLoginRecoveryCodeInputModel {
  /**
   * リカバリーコード
   * @type {string}
   * @memberof ContractLoginRecoveryCodeInputModel
   */
  recoveryCode?: string | null;
}
/**
 * 操作ログ一覧
 * @export
 * @interface ContractLogsViewModel
 */
export interface ContractLogsViewModel {
  /**
   * 全体の件数
   * @type {number}
   * @memberof ContractLogsViewModel
   */
  totalCount?: number;
  /**
   * 操作ログ一覧
   * @type {Array<ContractLogViewModel>}
   * @memberof ContractLogsViewModel
   */
  logs?: Array<ContractLogViewModel> | null;
}
/**
 * 契約したオプション
 * @export
 * @interface ContractOptionInputModel
 */
export interface ContractOptionInputModel {
  /**
   * 製品 ID
   * @type {string}
   * @memberof ContractOptionInputModel
   */
  productId: string;
  /**
   * オプション ID
   * @type {string}
   * @memberof ContractOptionInputModel
   */
  optionId: string;
  /**
   * オプション名
   * @type {string}
   * @memberof ContractOptionInputModel
   */
  optionName: string;
  /**
   * ライセンス数
   * @type {number}
   * @memberof ContractOptionInputModel
   */
  licenseCount?: number | null;
}
/**
 * 契約したオプション
 * @export
 * @interface ContractOptionViewModel
 */
export interface ContractOptionViewModel {
  /**
   * 製品 ID
   * @type {string}
   * @memberof ContractOptionViewModel
   */
  productId?: string | null;
  /**
   * オプション ID
   * @type {string}
   * @memberof ContractOptionViewModel
   */
  optionId?: string | null;
  /**
   * ライセンス数
   * @type {string}
   * @memberof ContractOptionViewModel
   */
  optionName?: string | null;
  /**
   * ライセンス数
   * @type {number}
   * @memberof ContractOptionViewModel
   */
  licenseCount?: number | null;
}
/**
 * 契約の基盤
 * @export
 * @interface ContractPlatformViewModel
 */
export interface ContractPlatformViewModel {
  /**
   * ID
   * @type {string}
   * @memberof ContractPlatformViewModel
   */
  id?: string | null;
  /**
   * 名称
   * @type {string}
   * @memberof ContractPlatformViewModel
   */
  name?: string | null;
  /**
   * ライセンス数
   * @type {number}
   * @memberof ContractPlatformViewModel
   */
  userCount?: number;
  /**
   * 標準データ容量
   * @type {number}
   * @memberof ContractPlatformViewModel
   */
  dataCapacity?: number;
}
/**
 * 契約製品の詳細
 * @export
 * @interface ContractProductDetailsViewModel
 */
export interface ContractProductDetailsViewModel {
  /**
   * 製品ID
   * @type {string}
   * @memberof ContractProductDetailsViewModel
   */
  productId?: string | null;
  /**
   * 製品名
   * @type {string}
   * @memberof ContractProductDetailsViewModel
   */
  productName?: string | null;
  /**
   * バージョン
   * @type {string}
   * @memberof ContractProductDetailsViewModel
   */
  version?: string | null;
  /**
   * ライセンス数
   * @type {number}
   * @memberof ContractProductDetailsViewModel
   */
  licenseCount?: number;
  /**
   * シリアル番号
   * @type {string}
   * @memberof ContractProductDetailsViewModel
   */
  serialNumber?: string | null;
  /**
   * DMSS番号
   * @type {string}
   * @memberof ContractProductDetailsViewModel
   */
  dmssNumber?: string | null;
  /**
   * 契約したオプション
   * @type {Array<ContractOptionViewModel>}
   * @memberof ContractProductDetailsViewModel
   */
  options?: Array<ContractOptionViewModel> | null;
}
/**
 * 組織に紐づくテナントが利用している製品
 * @export
 * @interface ContractProductViewModel
 */
export interface ContractProductViewModel {
  /**
   * テナント ID
   * @type {string}
   * @memberof ContractProductViewModel
   */
  tenantId?: string | null;
  /**
   * 製品 ID
   * @type {string}
   * @memberof ContractProductViewModel
   */
  productId?: string | null;
  /**
   * 製品名
   * @type {string}
   * @memberof ContractProductViewModel
   */
  productName?: string | null;
  /**
   * 製品バージョン
   * @type {string}
   * @memberof ContractProductViewModel
   */
  version?: string | null;
  /**
   * シリアル番号
   * @type {string}
   * @memberof ContractProductViewModel
   */
  serialNumber?: string | null;
  /**
   * アップグレード可能かどうか
   * @type {boolean}
   * @memberof ContractProductViewModel
   */
  canUpgrade?: boolean;
  /**
   * アップグレード可能なバージョンの一覧
   * @type {Array<string>}
   * @memberof ContractProductViewModel
   */
  upgradableVersions?: Array<string> | null;
}
/**
 * 契約
 * @export
 * @interface ContractViewModel
 */
export interface ContractViewModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof ContractViewModel
   */
  id?: string | null;
  /**
   * 会社名
   * @type {string}
   * @memberof ContractViewModel
   */
  companyName?: string | null;
  /**
   * パスワード変更が必要かどうか
   * @type {boolean}
   * @memberof ContractViewModel
   */
  requiresPasswordChange?: boolean;
  /**
   * 無償体験かどうか
   * @type {boolean}
   * @memberof ContractViewModel
   */
  trial?: boolean | null;
}
/**
 * CreateInstalledAppAsyncのインプットモデル
 * @export
 * @interface CreateInstalledAppInputModel
 */
export interface CreateInstalledAppInputModel {
  /**
   * 新規に連携するアプリのID
   * @type {string}
   * @memberof CreateInstalledAppInputModel
   */
  applicationId: string;
}
/**
 * CreateInstalledAppAsyncのビューモデル
 * @export
 * @interface CreateInstalledAppViewModel
 */
export interface CreateInstalledAppViewModel {
  /**
   * 連携アプリのID
   * @type {string}
   * @memberof CreateInstalledAppViewModel
   */
  applicationId?: string | null;
  /**
   * 連携アプリの名前
   * @type {string}
   * @memberof CreateInstalledAppViewModel
   */
  name?: string | null;
  /**
   * 連携アプリの説明
   * @type {string}
   * @memberof CreateInstalledAppViewModel
   */
  description?: string | null;
  /**
   * 連携アプリの対象製品ID
   * @type {string}
   * @memberof CreateInstalledAppViewModel
   */
  productId?: string | null;
  /**
   * 連携アプリのタイプ
   * @type {string}
   * @memberof CreateInstalledAppViewModel
   */
  type?: string | null;
  /**
   * 連携アプリのホームページURL
   * @type {string}
   * @memberof CreateInstalledAppViewModel
   */
  uri?: string | null;
}
/**
 * メール送信テストの入力
 * @export
 * @interface EmailTestInputModel
 */
export interface EmailTestInputModel {
  /**
   * メールアドレス
   * @type {string}
   * @memberof EmailTestInputModel
   */
  email: string;
}
/**
 * 二要素認証有効化のインプットモデル
 * @export
 * @interface Enable2faInputModel
 */
export interface Enable2faInputModel {
  /**
   * Authenticatorから発行された登録コード
   * @type {string}
   * @memberof Enable2faInputModel
   */
  registerCode?: string | null;
}
/**
 * 契約 ID 送信要求
 * @export
 * @interface ForgotContractIdInputModel
 */
export interface ForgotContractIdInputModel {
  /**
   * メールアドレス
   * @type {string}
   * @memberof ForgotContractIdInputModel
   */
  email: string;
}
/**
 * パスワードリセットトークン要求
 * @export
 * @interface ForgotContractPasswordInputModel
 */
export interface ForgotContractPasswordInputModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof ForgotContractPasswordInputModel
   */
  contractId: string;
  /**
   * メールアドレス
   * @type {string}
   * @memberof ForgotContractPasswordInputModel
   */
  email: string;
}
/**
 * GetInstalledAppDetailAsyncのビューモデル
 * @export
 * @interface GetInstalledAppDetailViewModel
 */
export interface GetInstalledAppDetailViewModel {
  /**
   * 連携アプリのID
   * @type {string}
   * @memberof GetInstalledAppDetailViewModel
   */
  applicationId?: string | null;
  /**
   * 連携アプリの名前
   * @type {string}
   * @memberof GetInstalledAppDetailViewModel
   */
  name?: string | null;
  /**
   * 連携アプリの説明
   * @type {string}
   * @memberof GetInstalledAppDetailViewModel
   */
  description?: string | null;
  /**
   * 連携アプリの対象製品ID
   * @type {string}
   * @memberof GetInstalledAppDetailViewModel
   */
  productId?: string | null;
  /**
   * 連携アプリのタイプ
   * @type {string}
   * @memberof GetInstalledAppDetailViewModel
   */
  type?: string | null;
  /**
   * 連携アプリのホームページURL
   * @type {string}
   * @memberof GetInstalledAppDetailViewModel
   */
  uri?: string | null;
}
/**
 * GetInstalledAppsAsyncのビューモデル
 * @export
 * @interface GetInstalledAppsViewModel
 */
export interface GetInstalledAppsViewModel {
  /**
   * 連携アプリ一覧
   * @type {Array<SimpleInstalledAppDetail>}
   * @memberof GetInstalledAppsViewModel
   */
  installedApplications?: Array<SimpleInstalledAppDetail> | null;
  /**
   *
   * @type {InstalledAppsMetaData}
   * @memberof GetInstalledAppsViewModel
   */
  meta?: InstalledAppsMetaData;
}
/**
 * WebHook イベント
 * @export
 * @interface HookEventViewModel
 */
export interface HookEventViewModel {
  /**
   * イベント名
   * @type {string}
   * @memberof HookEventViewModel
   */
  eventName?: string | null;
  /**
   * 表示用名称
   * @type {string}
   * @memberof HookEventViewModel
   */
  displayName?: string | null;
  /**
   * イベントの説明
   * @type {string}
   * @memberof HookEventViewModel
   */
  description?: string | null;
}
/**
 * 連携アプリ一覧のメタデータ
 * @export
 * @interface InstalledAppsMetaData
 */
export interface InstalledAppsMetaData {
  /**
   * 取得した連携アプリの数
   * @type {number}
   * @memberof InstalledAppsMetaData
   */
  total?: number;
}
/**
 * 二要素認証を有効にするために必要な情報のビューモデル
 * @export
 * @interface Issue2faSetupInfoViewModel
 */
export interface Issue2faSetupInfoViewModel {
  /**
   * 共有シークレット  手動でセットアップする際に必要
   * @type {string}
   * @memberof Issue2faSetupInfoViewModel
   */
  sharedKey?: string | null;
  /**
   * Authenticatorで読み取るQRコード用のURL
   * @type {string}
   * @memberof Issue2faSetupInfoViewModel
   */
  authenticatorUri?: string | null;
  /**
   * 既に二要素認証が有効になっているか
   * @type {boolean}
   * @memberof Issue2faSetupInfoViewModel
   */
  alreadyEnabled?: boolean;
}
/**
 * 管理ツール登録APIのインプットモデルです。
 * @export
 * @interface ManagementToolCreateInputModel
 */
export interface ManagementToolCreateInputModel {
  /**
   * バージョン
   * @type {string}
   * @memberof ManagementToolCreateInputModel
   */
  version: string;
  /**
   * IPアドレス
   * @type {string}
   * @memberof ManagementToolCreateInputModel
   */
  ipAddress: string;
}
/**
 * 管理ツール更新APIのインプットモデルです。
 * @export
 * @interface ManagementToolUpdateInputModel
 */
export interface ManagementToolUpdateInputModel {
  /**
   * IPアドレス
   * @type {string}
   * @memberof ManagementToolUpdateInputModel
   */
  ipAddress: string;
}
/**
 * 管理ツール更新APIのビューモデルです。
 * @export
 * @interface ManagementToolUpdateViewModel
 */
export interface ManagementToolUpdateViewModel {
  /**
   * 管理ツールのバージョン
   * @type {string}
   * @memberof ManagementToolUpdateViewModel
   */
  version: string;
  /**
   * クライアントデータ
   * @type {string}
   * @memberof ManagementToolUpdateViewModel
   */
  clientData: string;
}
/**
 * 管理ツールバージョンのビューモデルです。
 * @export
 * @interface ManagementToolVersionViewModel
 */
export interface ManagementToolVersionViewModel {
  /**
   * バージョン
   * @type {string}
   * @memberof ManagementToolVersionViewModel
   */
  version?: string | null;
  /**
   * クライアント通信設定
   * @type {string}
   * @memberof ManagementToolVersionViewModel
   */
  clientData?: string | null;
}
/**
 *
 * @export
 * @interface Operation
 */
export interface Operation {
  /**
   *
   * @type {OperationType}
   * @memberof Operation
   */
  operationType?: OperationType;
  /**
   *
   * @type {string}
   * @memberof Operation
   */
  path?: string | null;
  /**
   *
   * @type {string}
   * @memberof Operation
   */
  op?: string | null;
  /**
   *
   * @type {string}
   * @memberof Operation
   */
  from?: string | null;
  /**
   *
   * @type {any}
   * @memberof Operation
   */
  value?: any | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OperationType = {
  Add: "Add",
  Remove: "Remove",
  Replace: "Replace",
  Move: "Move",
  Copy: "Copy",
  Test: "Test",
  Invalid: "Invalid",
} as const;

export type OperationType = (typeof OperationType)[keyof typeof OperationType];

/**
 * パスワードポリシー
 * @export
 * @interface PasswordPolicyViewModel
 */
export interface PasswordPolicyViewModel {
  /**
   * 最小の長さ
   * @type {number}
   * @memberof PasswordPolicyViewModel
   */
  minLength?: number;
  /**
   * 複雑なパスワードが必要かどうか
   * @type {boolean}
   * @memberof PasswordPolicyViewModel
   */
  requireComplexity?: boolean;
}
/**
 *
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
  [key: string]: any | any;

  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof ProblemDetails
   */
  status?: number | null;
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  instance?: string | null;
}
/**
 * 製品API登録に使用するインプットモデルを表します。
 * @export
 * @interface ProductApiRegisterInputModel
 */
export interface ProductApiRegisterInputModel {
  /**
   * ロードバランサのIPアドレス
   * @type {string}
   * @memberof ProductApiRegisterInputModel
   */
  loadBalancerIpAddress: string;
}
/**
 * 登録済製品APIを表します。
 * @export
 * @interface ProductApiRegisterViewModel
 */
export interface ProductApiRegisterViewModel {
  /**
   * 製品バージョン
   * @type {string}
   * @memberof ProductApiRegisterViewModel
   */
  productId?: string | null;
  /**
   * バージョン
   * @type {string}
   * @memberof ProductApiRegisterViewModel
   */
  version?: string | null;
  /**
   * Web APIのベースアドレス
   * @type {string}
   * @memberof ProductApiRegisterViewModel
   */
  bassAddress?: string | null;
}
/**
 * 製品API更新に使用するインプットモデルを表します。
 * @export
 * @interface ProductApiUpdateInputModel
 */
export interface ProductApiUpdateInputModel {
  /**
   * ロードバランサのIPアドレス
   * @type {string}
   * @memberof ProductApiUpdateInputModel
   */
  loadBalancerIpAddress: string;
}
/**
 * 更新済製品APIを表します。
 * @export
 * @interface ProductApiUpdateViewModel
 */
export interface ProductApiUpdateViewModel {
  /**
   * 製品バージョン
   * @type {string}
   * @memberof ProductApiUpdateViewModel
   */
  productId?: string | null;
  /**
   * バージョン
   * @type {string}
   * @memberof ProductApiUpdateViewModel
   */
  version?: string | null;
  /**
   * Web APIのベースアドレス
   * @type {string}
   * @memberof ProductApiUpdateViewModel
   */
  bassAddress?: string | null;
}
/**
 * 製品バージョンの管理ツールバージョン更新に使用するインプットモデルを表します。
 * @export
 * @interface ProductVersionManagementToolsVersionUpdateInputModel
 */
export interface ProductVersionManagementToolsVersionUpdateInputModel {
  /**
   * 管理ツールバージョン
   * @type {string}
   * @memberof ProductVersionManagementToolsVersionUpdateInputModel
   */
  version: string;
}
/**
 * 製品バージョン登録に使用するインプットモデルを表します。
 * @export
 * @interface ProductVersionRegisterInputModel
 */
export interface ProductVersionRegisterInputModel {
  /**
   * AXクラウドの製品バージョン
   * @type {string}
   * @memberof ProductVersionRegisterInputModel
   */
  productVersion: string;
  /**
   * 管理ツールのバージョン
   * @type {string}
   * @memberof ProductVersionRegisterInputModel
   */
  managementToolVersion: string;
  /**
   * IPアドレス
   * @type {string}
   * @memberof ProductVersionRegisterInputModel
   */
  ipAddress: string;
  /**
   * 非公開かどうか
   * @type {boolean}
   * @memberof ProductVersionRegisterInputModel
   */
  isPrivate?: boolean | null;
  /**
   * マニュアルURL
   * @type {string}
   * @memberof ProductVersionRegisterInputModel
   */
  manualUrl?: string | null;
  /**
   * アップデート期限
   * @type {string}
   * @memberof ProductVersionRegisterInputModel
   */
  updateDeadLine?: string | null;
}
/**
 * 登録済の製品バージョンを表します。
 * @export
 * @interface ProductVersionRegisterViewModel
 */
export interface ProductVersionRegisterViewModel {
  /**
   * 製品バージョン
   * @type {string}
   * @memberof ProductVersionRegisterViewModel
   */
  productId?: string | null;
  /**
   * AXクラウドの製品バージョン
   * @type {string}
   * @memberof ProductVersionRegisterViewModel
   */
  productVersion?: string | null;
  /**
   * 管理ツールのバージョン
   * @type {string}
   * @memberof ProductVersionRegisterViewModel
   */
  managementToolVersion?: string | null;
  /**
   * クライアントデータ
   * @type {string}
   * @memberof ProductVersionRegisterViewModel
   */
  clientData?: string | null;
  /**
   * 非公開かどうか
   * @type {boolean}
   * @memberof ProductVersionRegisterViewModel
   */
  isPrivate?: boolean | null;
  /**
   * マニュアルURL
   * @type {string}
   * @memberof ProductVersionRegisterViewModel
   */
  manualUrl?: string | null;
  /**
   * アップデート期限
   * @type {string}
   * @memberof ProductVersionRegisterViewModel
   */
  updateDeadLine?: string | null;
}
/**
 * 製品バージョン更新に使用するインプットモデルを表します。
 * @export
 * @interface ProductVersionUpdateInputModel
 */
export interface ProductVersionUpdateInputModel {
  /**
   * IPアドレス
   * @type {string}
   * @memberof ProductVersionUpdateInputModel
   */
  ipAddress: string;
}
/**
 * 更新済の製品バージョンを表します。
 * @export
 * @interface ProductVersionUpdateViewModel
 */
export interface ProductVersionUpdateViewModel {
  /**
   * 製品バージョン
   * @type {string}
   * @memberof ProductVersionUpdateViewModel
   */
  productId?: string | null;
  /**
   * AXクラウドの製品バージョン
   * @type {string}
   * @memberof ProductVersionUpdateViewModel
   */
  productVersion?: string | null;
  /**
   * クライアントデータ
   * @type {string}
   * @memberof ProductVersionUpdateViewModel
   */
  clientData?: string | null;
}
/**
 * 製品バージョンのビュー モデルを表します。
 * @export
 * @interface ProductVersionViewModel
 */
export interface ProductVersionViewModel {
  /**
   * 製品 ID
   * @type {string}
   * @memberof ProductVersionViewModel
   */
  productId?: string | null;
  /**
   * 製品バージョン
   * @type {string}
   * @memberof ProductVersionViewModel
   */
  productVersion?: string | null;
  /**
   * 管理ツールのバージョン
   * @type {string}
   * @memberof ProductVersionViewModel
   */
  managementToolVersion?: string | null;
  /**
   * クライアントデータ
   * @type {string}
   * @memberof ProductVersionViewModel
   */
  clientData?: string | null;
  /**
   * 非公開かどうか
   * @type {boolean}
   * @memberof ProductVersionViewModel
   */
  isPrivate?: boolean | null;
  /**
   * マニュアル URL
   * @type {string}
   * @memberof ProductVersionViewModel
   */
  manualUrl?: string | null;
  /**
   * アップデート期限
   * @type {string}
   * @memberof ProductVersionViewModel
   */
  updateDeadLine?: string | null;
}
/**
 * リカバリーコードのビューモデル
 * @export
 * @interface RecoveryCodesViewModel
 */
export interface RecoveryCodesViewModel {
  /**
   * リカバリーコード群
   * @type {Array<string>}
   * @memberof RecoveryCodesViewModel
   */
  recoveryCodes?: Array<string> | null;
}
/**
 * アプリの登録内容
 * @export
 * @interface RegisterApplicationInputModel
 */
export interface RegisterApplicationInputModel {
  /**
   * アプリ名
   * @type {string}
   * @memberof RegisterApplicationInputModel
   */
  name: string;
  /**
   * 概要
   * @type {string}
   * @memberof RegisterApplicationInputModel
   */
  description?: string | null;
  /**
   * 連係する製品
   * @type {string}
   * @memberof RegisterApplicationInputModel
   */
  productId: string;
  /**
   *
   * @type {ApplicationType}
   * @memberof RegisterApplicationInputModel
   */
  type: ApplicationType;
}
/**
 * テナント情報
 * @export
 * @interface RegisterTenantInputModel
 */
export interface RegisterTenantInputModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  contractId: string;
  /**
   * 会社名1
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  companyName: string;
  /**
   * 利用期間開始日
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  startDate: string;
  /**
   * 利用期間終了日
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  endDate: string;
  /**
   * メールアドレス
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  email: string;
  /**
   * 認証コード
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  authenticationCode?: string | null;
  /**
   * ポータルにログインするための初期パスワード
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  password: string;
  /**
   * テナント用 OH_SYSTEM のパスワード
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  ohSystemPassword: string;
  /**
   * テナント用 OH_DB_CREATOR のパスワード
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  ohDbCreatorPassword: string;
  /**
   * 利用ユーザー
   * @type {string}
   * @memberof RegisterTenantInputModel
   */
  platformId: string;
  /**
   * 追加データ容量
   * @type {number}
   * @memberof RegisterTenantInputModel
   */
  additionalDataCapacity?: number;
  /**
   * 追加データ領域数
   * @type {number}
   * @memberof RegisterTenantInputModel
   */
  additionalDataAreaCount?: number;
  /**
   * 無償体験
   * @type {boolean}
   * @memberof RegisterTenantInputModel
   */
  trial?: boolean | null;
  /**
   * テナント利用製品
   * @type {Array<TenantProductInputModel>}
   * @memberof RegisterTenantInputModel
   */
  products: Array<TenantProductInputModel>;
  /**
   * 契約したオプション
   * @type {Array<ContractOptionInputModel>}
   * @memberof RegisterTenantInputModel
   */
  options?: Array<ContractOptionInputModel> | null;
}
/**
 * 大臣AXクラウドのシステム管理者の新しいパスワード
 * @export
 * @interface ResetAdministratorPasswordInputModel
 */
export interface ResetAdministratorPasswordInputModel {
  /**
   * 新しいパスワード
   * @type {string}
   * @memberof ResetAdministratorPasswordInputModel
   */
  newPassword: string;
  /**
   * 新しいパスワード(確認用)
   * @type {string}
   * @memberof ResetAdministratorPasswordInputModel
   */
  newPasswordConfirmation: string;
}
/**
 * パスワードリセット要求
 * @export
 * @interface ResetContractPasswordInputModel
 */
export interface ResetContractPasswordInputModel {
  /**
   * 契約 ID
   * @type {string}
   * @memberof ResetContractPasswordInputModel
   */
  contractId: string;
  /**
   * パスワードリセットトークン
   * @type {string}
   * @memberof ResetContractPasswordInputModel
   */
  token: string;
  /**
   * 新しいパスワード
   * @type {string}
   * @memberof ResetContractPasswordInputModel
   */
  newPassword: string;
}
/**
 * リストのための簡略化された詳細
 * @export
 * @interface SimpleInstalledAppDetail
 */
export interface SimpleInstalledAppDetail {
  /**
   * 連携アプリのID
   * @type {string}
   * @memberof SimpleInstalledAppDetail
   */
  applicationId?: string | null;
  /**
   * 連携アプリの名前
   * @type {string}
   * @memberof SimpleInstalledAppDetail
   */
  name?: string | null;
  /**
   * 連携アプリの説明
   * @type {string}
   * @memberof SimpleInstalledAppDetail
   */
  description?: string | null;
}
/**
 * ストレージ情報
 * @export
 * @interface StorageInfoViewModel
 */
export interface StorageInfoViewModel {
  /**
   * 契約サイズ（MB）を取得します。
   * @type {number}
   * @memberof StorageInfoViewModel
   */
  contractCapacity?: number;
  /**
   * 使用済み領域のサイズ（MB）を取得します。
   * @type {number}
   * @memberof StorageInfoViewModel
   */
  usage?: number;
}
/**
 * テナント利用製品
 * @export
 * @interface TenantProductInputModel
 */
export interface TenantProductInputModel {
  /**
   * 製品 ID
   * @type {string}
   * @memberof TenantProductInputModel
   */
  productId: string;
  /**
   * 製品名
   * @type {string}
   * @memberof TenantProductInputModel
   */
  productName: string;
  /**
   * ライセンス数
   * @type {number}
   * @memberof TenantProductInputModel
   */
  licenseCount: number;
  /**
   * シリアル番号
   * @type {string}
   * @memberof TenantProductInputModel
   */
  serialNumber: string;
  /**
   * DMSS 番号
   * @type {string}
   * @memberof TenantProductInputModel
   */
  dmssNumber: string;
}
/**
 * テナント製品バージョン更新のインプットモデル
 * @export
 * @interface TenantProductVersionUpdateInputModel
 */
export interface TenantProductVersionUpdateInputModel {
  /**
   * 更新したいバージョン
   * @type {string}
   * @memberof TenantProductVersionUpdateInputModel
   */
  nextVersion: string;
}
/**
 * テナント製品バージョン更新のビューモデル
 * @export
 * @interface TenantProductVersionUpdateViewModel
 */
export interface TenantProductVersionUpdateViewModel {
  /**
   * 更新した製品のID
   * @type {string}
   * @memberof TenantProductVersionUpdateViewModel
   */
  productId?: string | null;
  /**
   * 製品の更新後のバージョン
   * @type {string}
   * @memberof TenantProductVersionUpdateViewModel
   */
  version?: string | null;
}
/**
 * テナント
 * @export
 * @interface TenantViewModel
 */
export interface TenantViewModel {
  /**
   * テナント ID
   * @type {string}
   * @memberof TenantViewModel
   */
  id?: string | null;
  /**
   * テナント名
   * @type {string}
   * @memberof TenantViewModel
   */
  name?: string | null;
  /**
   * エラスティックプール名
   * @type {string}
   * @memberof TenantViewModel
   */
  elasticPoolName?: string | null;
  /**
   * SQL Server 名
   * @type {string}
   * @memberof TenantViewModel
   */
  sqlServerName?: string | null;
}
/**
 * アクセストークン
 * @export
 * @interface TokenViewModel
 */
export interface TokenViewModel {
  /**
   * アクセストークン
   * @type {string}
   * @memberof TokenViewModel
   */
  accessToken?: string | null;
  /**
   * 有効期限
   * @type {string}
   * @memberof TokenViewModel
   */
  expires?: string;
  /**
   *
   * @type {ContractViewModel}
   * @memberof TokenViewModel
   */
  contract?: ContractViewModel;
  /**
   * 二要素認証が要求されているか
   * @type {boolean}
   * @memberof TokenViewModel
   */
  required2fa?: boolean;
}
/**
 * アプリの変更内容
 * @export
 * @interface UpdateApplicationInputModel
 */
export interface UpdateApplicationInputModel {
  /**
   * アプリ名
   * @type {string}
   * @memberof UpdateApplicationInputModel
   */
  name: string;
  /**
   * 概要
   * @type {string}
   * @memberof UpdateApplicationInputModel
   */
  description?: string | null;
  /**
   * ホームページ URL
   * @type {string}
   * @memberof UpdateApplicationInputModel
   */
  uri: string;
  /**
   * コールバック URL
   * @type {string}
   * @memberof UpdateApplicationInputModel
   */
  redirectUri: string;
  /**
   * Webhook を使用する
   * @type {boolean}
   * @memberof UpdateApplicationInputModel
   */
  webHookEnabled: boolean;
  /**
   * Webhook URL
   * @type {string}
   * @memberof UpdateApplicationInputModel
   */
  webHookUrl?: string | null;
  /**
   * Webhook Secret
   * @type {string}
   * @memberof UpdateApplicationInputModel
   */
  webHookSecret?: string | null;
  /**
   *
   * @type {WebHookFilterMode}
   * @memberof UpdateApplicationInputModel
   */
  webHookFilterMode?: WebHookFilterMode;
  /**
   * Webhook イベント
   * @type {Array<string>}
   * @memberof UpdateApplicationInputModel
   */
  webHookEvents?: Array<string> | null;
}
/**
 * 契約の更新内容
 * @export
 * @interface UpdateContractInputModel
 */
export interface UpdateContractInputModel {
  /**
   * 会社名
   * @type {string}
   * @memberof UpdateContractInputModel
   */
  companyName?: string | null;
}
/**
 * 製品のアップグレード情報
 * @export
 * @interface UpgradeProductInputModel
 */
export interface UpgradeProductInputModel {
  /**
   * 新しいバージョン
   * @type {string}
   * @memberof UpgradeProductInputModel
   */
  version: string;
}
/**
 *
 * @export
 * @interface ValidationProblemDetails
 */
export interface ValidationProblemDetails {
  [key: string]: any | any;

  /**
   *
   * @type {string}
   * @memberof ValidationProblemDetails
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationProblemDetails
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof ValidationProblemDetails
   */
  status?: number | null;
  /**
   *
   * @type {string}
   * @memberof ValidationProblemDetails
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationProblemDetails
   */
  instance?: string | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ValidationProblemDetails
   */
  errors?: { [key: string]: Array<string> } | null;
}
/**
 * Web フックのフィルタのモード
 * @export
 * @enum {string}
 */

export const WebHookFilterMode = {
  All: "All",
  Select: "Select",
} as const;

export type WebHookFilterMode =
  (typeof WebHookFilterMode)[keyof typeof WebHookFilterMode];

/**
 * AdminContractProductsApi - axios parameter creator
 * @export
 */
export const AdminContractProductsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary テナントの製品バージョンを一括更新します。
     * @param {string} productId
     * @param {string} currentVersion
     * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateTenantProductVersionAsync: async (
      productId: string,
      currentVersion: string,
      tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists(
        "bulkUpdateTenantProductVersionAsync",
        "productId",
        productId
      );
      // verify required parameter 'currentVersion' is not null or undefined
      assertParamExists(
        "bulkUpdateTenantProductVersionAsync",
        "currentVersion",
        currentVersion
      );
      const localVarPath =
        `/api/admin/contracts/@all/products/{productId}/versions/{currentVersion}`
          .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
          .replace(
            `{${"currentVersion"}}`,
            encodeURIComponent(String(currentVersion))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenantProductVersionUpdateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary テナントの製品バージョンを更新します。
     * @param {string} contractId
     * @param {string} productId
     * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTenantProductVersionAsync: async (
      contractId: string,
      productId: string,
      tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractId' is not null or undefined
      assertParamExists(
        "updateTenantProductVersionAsync",
        "contractId",
        contractId
      );
      // verify required parameter 'productId' is not null or undefined
      assertParamExists(
        "updateTenantProductVersionAsync",
        "productId",
        productId
      );
      const localVarPath =
        `/api/admin/contracts/{contractId}/products/{productId}`
          .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)))
          .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenantProductVersionUpdateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AdminContractProductsApi - functional programming interface
 * @export
 */
export const AdminContractProductsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    AdminContractProductsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary テナントの製品バージョンを一括更新します。
     * @param {string} productId
     * @param {string} currentVersion
     * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkUpdateTenantProductVersionAsync(
      productId: string,
      currentVersion: string,
      tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.bulkUpdateTenantProductVersionAsync(
          productId,
          currentVersion,
          tenantProductVersionUpdateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary テナントの製品バージョンを更新します。
     * @param {string} contractId
     * @param {string} productId
     * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTenantProductVersionAsync(
      contractId: string,
      productId: string,
      tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TenantProductVersionUpdateViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateTenantProductVersionAsync(
          contractId,
          productId,
          tenantProductVersionUpdateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * AdminContractProductsApi - factory interface
 * @export
 */
export const AdminContractProductsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminContractProductsApiFp(configuration);
  return {
    /**
     *
     * @summary テナントの製品バージョンを一括更新します。
     * @param {string} productId
     * @param {string} currentVersion
     * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateTenantProductVersionAsync(
      productId: string,
      currentVersion: string,
      tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .bulkUpdateTenantProductVersionAsync(
          productId,
          currentVersion,
          tenantProductVersionUpdateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary テナントの製品バージョンを更新します。
     * @param {string} contractId
     * @param {string} productId
     * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTenantProductVersionAsync(
      contractId: string,
      productId: string,
      tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
      options?: any
    ): AxiosPromise<TenantProductVersionUpdateViewModel> {
      return localVarFp
        .updateTenantProductVersionAsync(
          contractId,
          productId,
          tenantProductVersionUpdateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AdminContractProductsApi - object-oriented interface
 * @export
 * @class AdminContractProductsApi
 * @extends {BaseAPI}
 */
export class AdminContractProductsApi extends BaseAPI {
  /**
   *
   * @summary テナントの製品バージョンを一括更新します。
   * @param {string} productId
   * @param {string} currentVersion
   * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminContractProductsApi
   */
  public bulkUpdateTenantProductVersionAsync(
    productId: string,
    currentVersion: string,
    tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
    options?: AxiosRequestConfig
  ) {
    return AdminContractProductsApiFp(this.configuration)
      .bulkUpdateTenantProductVersionAsync(
        productId,
        currentVersion,
        tenantProductVersionUpdateInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary テナントの製品バージョンを更新します。
   * @param {string} contractId
   * @param {string} productId
   * @param {TenantProductVersionUpdateInputModel} [tenantProductVersionUpdateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminContractProductsApi
   */
  public updateTenantProductVersionAsync(
    contractId: string,
    productId: string,
    tenantProductVersionUpdateInputModel?: TenantProductVersionUpdateInputModel,
    options?: AxiosRequestConfig
  ) {
    return AdminContractProductsApiFp(this.configuration)
      .updateTenantProductVersionAsync(
        contractId,
        productId,
        tenantProductVersionUpdateInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ApplicationsApi - axios parameter creator
 * @export
 */
export const ApplicationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary アプリを削除します。
     * @param {string} applicationId アプリ ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteApplication: async (
      applicationId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'applicationId' is not null or undefined
      assertParamExists("deleteApplication", "applicationId", applicationId);
      const localVarPath = `/api/applications/{applicationId}`.replace(
        `{${"applicationId"}}`,
        encodeURIComponent(String(applicationId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アプリの詳細を取得します。
     * @param {string} applicationId アプリ ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplication: async (
      applicationId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'applicationId' is not null or undefined
      assertParamExists("getApplication", "applicationId", applicationId);
      const localVarPath = `/api/applications/{applicationId}`.replace(
        `{${"applicationId"}}`,
        encodeURIComponent(String(applicationId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アプリの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listApplications: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/applications`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 新しいアプリを登録します。
     * @param {RegisterApplicationInputModel} [registerApplicationInputModel] アプリの登録内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerApplication: async (
      registerApplicationInputModel?: RegisterApplicationInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/applications`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerApplicationInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アプリを更新します。
     * @param {string} applicationId アプリ ID
     * @param {UpdateApplicationInputModel} [updateApplicationInputModel] アプリの変更内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateApplication: async (
      applicationId: string,
      updateApplicationInputModel?: UpdateApplicationInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'applicationId' is not null or undefined
      assertParamExists("updateApplication", "applicationId", applicationId);
      const localVarPath = `/api/applications/{applicationId}`.replace(
        `{${"applicationId"}}`,
        encodeURIComponent(String(applicationId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateApplicationInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ApplicationsApi - functional programming interface
 * @export
 */
export const ApplicationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ApplicationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary アプリを削除します。
     * @param {string} applicationId アプリ ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteApplication(
      applicationId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteApplication(
          applicationId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary アプリの詳細を取得します。
     * @param {string} applicationId アプリ ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getApplication(
      applicationId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ApplicationDetailsViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getApplication(
        applicationId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary アプリの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listApplications(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ApplicationViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listApplications(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 新しいアプリを登録します。
     * @param {RegisterApplicationInputModel} [registerApplicationInputModel] アプリの登録内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registerApplication(
      registerApplicationInputModel?: RegisterApplicationInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ApplicationViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registerApplication(
          registerApplicationInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary アプリを更新します。
     * @param {string} applicationId アプリ ID
     * @param {UpdateApplicationInputModel} [updateApplicationInputModel] アプリの変更内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateApplication(
      applicationId: string,
      updateApplicationInputModel?: UpdateApplicationInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ApplicationDetailsViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateApplication(
          applicationId,
          updateApplicationInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ApplicationsApi - factory interface
 * @export
 */
export const ApplicationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ApplicationsApiFp(configuration);
  return {
    /**
     *
     * @summary アプリを削除します。
     * @param {string} applicationId アプリ ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteApplication(
      applicationId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .deleteApplication(applicationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary アプリの詳細を取得します。
     * @param {string} applicationId アプリ ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplication(
      applicationId: string,
      options?: any
    ): AxiosPromise<ApplicationDetailsViewModel> {
      return localVarFp
        .getApplication(applicationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary アプリの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listApplications(options?: any): AxiosPromise<Array<ApplicationViewModel>> {
      return localVarFp
        .listApplications(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 新しいアプリを登録します。
     * @param {RegisterApplicationInputModel} [registerApplicationInputModel] アプリの登録内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerApplication(
      registerApplicationInputModel?: RegisterApplicationInputModel,
      options?: any
    ): AxiosPromise<ApplicationViewModel> {
      return localVarFp
        .registerApplication(registerApplicationInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary アプリを更新します。
     * @param {string} applicationId アプリ ID
     * @param {UpdateApplicationInputModel} [updateApplicationInputModel] アプリの変更内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateApplication(
      applicationId: string,
      updateApplicationInputModel?: UpdateApplicationInputModel,
      options?: any
    ): AxiosPromise<ApplicationDetailsViewModel> {
      return localVarFp
        .updateApplication(applicationId, updateApplicationInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ApplicationsApi - object-oriented interface
 * @export
 * @class ApplicationsApi
 * @extends {BaseAPI}
 */
export class ApplicationsApi extends BaseAPI {
  /**
   *
   * @summary アプリを削除します。
   * @param {string} applicationId アプリ ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationsApi
   */
  public deleteApplication(
    applicationId: string,
    options?: AxiosRequestConfig
  ) {
    return ApplicationsApiFp(this.configuration)
      .deleteApplication(applicationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary アプリの詳細を取得します。
   * @param {string} applicationId アプリ ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationsApi
   */
  public getApplication(applicationId: string, options?: AxiosRequestConfig) {
    return ApplicationsApiFp(this.configuration)
      .getApplication(applicationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary アプリの一覧を取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationsApi
   */
  public listApplications(options?: AxiosRequestConfig) {
    return ApplicationsApiFp(this.configuration)
      .listApplications(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 新しいアプリを登録します。
   * @param {RegisterApplicationInputModel} [registerApplicationInputModel] アプリの登録内容
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationsApi
   */
  public registerApplication(
    registerApplicationInputModel?: RegisterApplicationInputModel,
    options?: AxiosRequestConfig
  ) {
    return ApplicationsApiFp(this.configuration)
      .registerApplication(registerApplicationInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary アプリを更新します。
   * @param {string} applicationId アプリ ID
   * @param {UpdateApplicationInputModel} [updateApplicationInputModel] アプリの変更内容
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationsApi
   */
  public updateApplication(
    applicationId: string,
    updateApplicationInputModel?: UpdateApplicationInputModel,
    options?: AxiosRequestConfig
  ) {
    return ApplicationsApiFp(this.configuration)
      .updateApplication(applicationId, updateApplicationInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractApi - axios parameter creator
 * @export
 */
export const ContractApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary パスワードを変更します。
     * @param {ChangeContractPasswordInputModel} [changeContractPasswordInputModel] パスワード変更要求
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeContractPassword: async (
      changeContractPasswordInputModel?: ChangeContractPasswordInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        changeContractPasswordInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 指定したメールアドレスに紐づく契約 ID をメールで通知します。
     * @param {ForgotContractIdInputModel} [forgotContractIdInputModel] 契約IDの送信先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotContractId: async (
      forgotContractIdInputModel?: ForgotContractIdInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/id/forgot`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        forgotContractIdInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 指定した契約 ID に紐づくメールアドレスに、パスワードリセットトークンをメールで送信します。
     * @param {ForgotContractPasswordInputModel} [forgotContractPasswordInputModel] パスワードリセットトークン送信先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotContractPassword: async (
      forgotContractPasswordInputModel?: ForgotContractPasswordInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/password/forgot`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        forgotContractPasswordInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 契約の詳細を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContractDetails: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 契約情報を変更します。
     * @param {Array<Operation>} [operation] 変更内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchContract: async (
      operation?: Array<Operation>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        operation,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary パスワードをリセットします。
     * @param {ResetContractPasswordInputModel} [resetContractPasswordInputModel] パスワードリセット要求
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetContractPassword: async (
      resetContractPasswordInputModel?: ResetContractPasswordInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/password/reset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resetContractPasswordInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractApi - functional programming interface
 * @export
 */
export const ContractApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContractApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary パスワードを変更します。
     * @param {ChangeContractPasswordInputModel} [changeContractPasswordInputModel] パスワード変更要求
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeContractPassword(
      changeContractPasswordInputModel?: ChangeContractPasswordInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.changeContractPassword(
          changeContractPasswordInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 指定したメールアドレスに紐づく契約 ID をメールで通知します。
     * @param {ForgotContractIdInputModel} [forgotContractIdInputModel] 契約IDの送信先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotContractId(
      forgotContractIdInputModel?: ForgotContractIdInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.forgotContractId(
          forgotContractIdInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 指定した契約 ID に紐づくメールアドレスに、パスワードリセットトークンをメールで送信します。
     * @param {ForgotContractPasswordInputModel} [forgotContractPasswordInputModel] パスワードリセットトークン送信先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotContractPassword(
      forgotContractPasswordInputModel?: ForgotContractPasswordInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.forgotContractPassword(
          forgotContractPasswordInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 契約の詳細を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContractDetails(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractDetailsViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getContractDetails(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 契約情報を変更します。
     * @param {Array<Operation>} [operation] 変更内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchContract(
      operation?: Array<Operation>,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractDetailsViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchContract(
        operation,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary パスワードをリセットします。
     * @param {ResetContractPasswordInputModel} [resetContractPasswordInputModel] パスワードリセット要求
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetContractPassword(
      resetContractPasswordInputModel?: ResetContractPasswordInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.resetContractPassword(
          resetContractPasswordInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractApi - factory interface
 * @export
 */
export const ContractApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractApiFp(configuration);
  return {
    /**
     *
     * @summary パスワードを変更します。
     * @param {ChangeContractPasswordInputModel} [changeContractPasswordInputModel] パスワード変更要求
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeContractPassword(
      changeContractPasswordInputModel?: ChangeContractPasswordInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .changeContractPassword(changeContractPasswordInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 指定したメールアドレスに紐づく契約 ID をメールで通知します。
     * @param {ForgotContractIdInputModel} [forgotContractIdInputModel] 契約IDの送信先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotContractId(
      forgotContractIdInputModel?: ForgotContractIdInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .forgotContractId(forgotContractIdInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 指定した契約 ID に紐づくメールアドレスに、パスワードリセットトークンをメールで送信します。
     * @param {ForgotContractPasswordInputModel} [forgotContractPasswordInputModel] パスワードリセットトークン送信先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotContractPassword(
      forgotContractPasswordInputModel?: ForgotContractPasswordInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .forgotContractPassword(forgotContractPasswordInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 契約の詳細を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContractDetails(options?: any): AxiosPromise<ContractDetailsViewModel> {
      return localVarFp
        .getContractDetails(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 契約情報を変更します。
     * @param {Array<Operation>} [operation] 変更内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchContract(
      operation?: Array<Operation>,
      options?: any
    ): AxiosPromise<ContractDetailsViewModel> {
      return localVarFp
        .patchContract(operation, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary パスワードをリセットします。
     * @param {ResetContractPasswordInputModel} [resetContractPasswordInputModel] パスワードリセット要求
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetContractPassword(
      resetContractPasswordInputModel?: ResetContractPasswordInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .resetContractPassword(resetContractPasswordInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractApi - object-oriented interface
 * @export
 * @class ContractApi
 * @extends {BaseAPI}
 */
export class ContractApi extends BaseAPI {
  /**
   *
   * @summary パスワードを変更します。
   * @param {ChangeContractPasswordInputModel} [changeContractPasswordInputModel] パスワード変更要求
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public changeContractPassword(
    changeContractPasswordInputModel?: ChangeContractPasswordInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .changeContractPassword(changeContractPasswordInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 指定したメールアドレスに紐づく契約 ID をメールで通知します。
   * @param {ForgotContractIdInputModel} [forgotContractIdInputModel] 契約IDの送信先
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public forgotContractId(
    forgotContractIdInputModel?: ForgotContractIdInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .forgotContractId(forgotContractIdInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 指定した契約 ID に紐づくメールアドレスに、パスワードリセットトークンをメールで送信します。
   * @param {ForgotContractPasswordInputModel} [forgotContractPasswordInputModel] パスワードリセットトークン送信先
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public forgotContractPassword(
    forgotContractPasswordInputModel?: ForgotContractPasswordInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .forgotContractPassword(forgotContractPasswordInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 契約の詳細を取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public getContractDetails(options?: AxiosRequestConfig) {
    return ContractApiFp(this.configuration)
      .getContractDetails(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 契約情報を変更します。
   * @param {Array<Operation>} [operation] 変更内容
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public patchContract(
    operation?: Array<Operation>,
    options?: AxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .patchContract(operation, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary パスワードをリセットします。
   * @param {ResetContractPasswordInputModel} [resetContractPasswordInputModel] パスワードリセット要求
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public resetContractPassword(
    resetContractPasswordInputModel?: ResetContractPasswordInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .resetContractPassword(resetContractPasswordInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * Contract2faApi - axios parameter creator
 * @export
 */
export const Contract2faApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 二要素認証を解除します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disable2faAsync: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/2fa`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 二要素認証を有効にします。
     * @param {Enable2faInputModel} [enable2faInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enable2faAsync: async (
      enable2faInputModel?: Enable2faInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/2fa`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        enable2faInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 二要素認証を有効にするための情報を発行します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issue2faSetupInfo: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/2fa`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * Contract2faApi - functional programming interface
 * @export
 */
export const Contract2faApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    Contract2faApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 二要素認証を解除します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disable2faAsync(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disable2faAsync(
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 二要素認証を有効にします。
     * @param {Enable2faInputModel} [enable2faInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enable2faAsync(
      enable2faInputModel?: Enable2faInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<RecoveryCodesViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.enable2faAsync(
        enable2faInputModel,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 二要素認証を有効にするための情報を発行します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issue2faSetupInfo(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Issue2faSetupInfoViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.issue2faSetupInfo(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * Contract2faApi - factory interface
 * @export
 */
export const Contract2faApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = Contract2faApiFp(configuration);
  return {
    /**
     *
     * @summary 二要素認証を解除します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disable2faAsync(options?: any): AxiosPromise<void> {
      return localVarFp
        .disable2faAsync(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 二要素認証を有効にします。
     * @param {Enable2faInputModel} [enable2faInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enable2faAsync(
      enable2faInputModel?: Enable2faInputModel,
      options?: any
    ): AxiosPromise<RecoveryCodesViewModel> {
      return localVarFp
        .enable2faAsync(enable2faInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 二要素認証を有効にするための情報を発行します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issue2faSetupInfo(options?: any): AxiosPromise<Issue2faSetupInfoViewModel> {
      return localVarFp
        .issue2faSetupInfo(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Contract2faApi - object-oriented interface
 * @export
 * @class Contract2faApi
 * @extends {BaseAPI}
 */
export class Contract2faApi extends BaseAPI {
  /**
   *
   * @summary 二要素認証を解除します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof Contract2faApi
   */
  public disable2faAsync(options?: AxiosRequestConfig) {
    return Contract2faApiFp(this.configuration)
      .disable2faAsync(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 二要素認証を有効にします。
   * @param {Enable2faInputModel} [enable2faInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof Contract2faApi
   */
  public enable2faAsync(
    enable2faInputModel?: Enable2faInputModel,
    options?: AxiosRequestConfig
  ) {
    return Contract2faApiFp(this.configuration)
      .enable2faAsync(enable2faInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 二要素認証を有効にするための情報を発行します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof Contract2faApi
   */
  public issue2faSetupInfo(options?: AxiosRequestConfig) {
    return Contract2faApiFp(this.configuration)
      .issue2faSetupInfo(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractAccessKeysApi - axios parameter creator
 * @export
 */
export const ContractAccessKeysApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary アクセスキーを削除します。
     * @param {string} accessKeyId アクセスキー ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccessKey: async (
      accessKeyId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessKeyId' is not null or undefined
      assertParamExists("deleteAccessKey", "accessKeyId", accessKeyId);
      const localVarPath = `/api/contract/access-keys/{accessKeyId}`.replace(
        `{${"accessKeyId"}}`,
        encodeURIComponent(String(accessKeyId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary プライマリなアクセスキーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrimaryAccessKey: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/access-keys/primary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アクセスキーの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractAccessKeys: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/access-keys`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary プライマリなアクセスキーを再生成します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regeneratePrimaryAccessKey: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/access-keys/primary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アクセスキーを登録します。
     * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerContractAccessKey: async (
      accessKeyInputModel?: AccessKeyInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/access-keys`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessKeyInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アクセスキーを更新します。
     * @param {string} accessKeyId アクセスキー ID
     * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccessKey: async (
      accessKeyId: string,
      accessKeyInputModel?: AccessKeyInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessKeyId' is not null or undefined
      assertParamExists("updateAccessKey", "accessKeyId", accessKeyId);
      const localVarPath = `/api/contract/access-keys/{accessKeyId}`.replace(
        `{${"accessKeyId"}}`,
        encodeURIComponent(String(accessKeyId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessKeyInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractAccessKeysApi - functional programming interface
 * @export
 */
export const ContractAccessKeysApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ContractAccessKeysApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary アクセスキーを削除します。
     * @param {string} accessKeyId アクセスキー ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAccessKey(
      accessKeyId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccessKey(
        accessKeyId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary プライマリなアクセスキーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPrimaryAccessKey(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AccessKeyViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPrimaryAccessKey(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary アクセスキーの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listContractAccessKeys(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<AccessKeyViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listContractAccessKeys(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary プライマリなアクセスキーを再生成します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regeneratePrimaryAccessKey(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AccessKeyViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.regeneratePrimaryAccessKey(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary アクセスキーを登録します。
     * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registerContractAccessKey(
      accessKeyInputModel?: AccessKeyInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AccessKeyViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registerContractAccessKey(
          accessKeyInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary アクセスキーを更新します。
     * @param {string} accessKeyId アクセスキー ID
     * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccessKey(
      accessKeyId: string,
      accessKeyInputModel?: AccessKeyInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AccessKeyViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccessKey(
        accessKeyId,
        accessKeyInputModel,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractAccessKeysApi - factory interface
 * @export
 */
export const ContractAccessKeysApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractAccessKeysApiFp(configuration);
  return {
    /**
     *
     * @summary アクセスキーを削除します。
     * @param {string} accessKeyId アクセスキー ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccessKey(accessKeyId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteAccessKey(accessKeyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary プライマリなアクセスキーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrimaryAccessKey(options?: any): AxiosPromise<AccessKeyViewModel> {
      return localVarFp
        .getPrimaryAccessKey(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary アクセスキーの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractAccessKeys(
      options?: any
    ): AxiosPromise<Array<AccessKeyViewModel>> {
      return localVarFp
        .listContractAccessKeys(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary プライマリなアクセスキーを再生成します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regeneratePrimaryAccessKey(
      options?: any
    ): AxiosPromise<AccessKeyViewModel> {
      return localVarFp
        .regeneratePrimaryAccessKey(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary アクセスキーを登録します。
     * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerContractAccessKey(
      accessKeyInputModel?: AccessKeyInputModel,
      options?: any
    ): AxiosPromise<AccessKeyViewModel> {
      return localVarFp
        .registerContractAccessKey(accessKeyInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary アクセスキーを更新します。
     * @param {string} accessKeyId アクセスキー ID
     * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccessKey(
      accessKeyId: string,
      accessKeyInputModel?: AccessKeyInputModel,
      options?: any
    ): AxiosPromise<AccessKeyViewModel> {
      return localVarFp
        .updateAccessKey(accessKeyId, accessKeyInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractAccessKeysApi - object-oriented interface
 * @export
 * @class ContractAccessKeysApi
 * @extends {BaseAPI}
 */
export class ContractAccessKeysApi extends BaseAPI {
  /**
   *
   * @summary アクセスキーを削除します。
   * @param {string} accessKeyId アクセスキー ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractAccessKeysApi
   */
  public deleteAccessKey(accessKeyId: string, options?: AxiosRequestConfig) {
    return ContractAccessKeysApiFp(this.configuration)
      .deleteAccessKey(accessKeyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary プライマリなアクセスキーを取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractAccessKeysApi
   */
  public getPrimaryAccessKey(options?: AxiosRequestConfig) {
    return ContractAccessKeysApiFp(this.configuration)
      .getPrimaryAccessKey(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary アクセスキーの一覧を取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractAccessKeysApi
   */
  public listContractAccessKeys(options?: AxiosRequestConfig) {
    return ContractAccessKeysApiFp(this.configuration)
      .listContractAccessKeys(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary プライマリなアクセスキーを再生成します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractAccessKeysApi
   */
  public regeneratePrimaryAccessKey(options?: AxiosRequestConfig) {
    return ContractAccessKeysApiFp(this.configuration)
      .regeneratePrimaryAccessKey(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary アクセスキーを登録します。
   * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractAccessKeysApi
   */
  public registerContractAccessKey(
    accessKeyInputModel?: AccessKeyInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractAccessKeysApiFp(this.configuration)
      .registerContractAccessKey(accessKeyInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary アクセスキーを更新します。
   * @param {string} accessKeyId アクセスキー ID
   * @param {AccessKeyInputModel} [accessKeyInputModel] アクセスキーの情報
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractAccessKeysApi
   */
  public updateAccessKey(
    accessKeyId: string,
    accessKeyInputModel?: AccessKeyInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractAccessKeysApiFp(this.configuration)
      .updateAccessKey(accessKeyId, accessKeyInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractEmailApi - axios parameter creator
 * @export
 */
export const ContractEmailApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary メールをテスト送信します。
     * @param {EmailTestInputModel} [emailTestInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    test: async (
      emailTestInputModel?: EmailTestInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/email/test`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        emailTestInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractEmailApi - functional programming interface
 * @export
 */
export const ContractEmailApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContractEmailApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary メールをテスト送信します。
     * @param {EmailTestInputModel} [emailTestInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async test(
      emailTestInputModel?: EmailTestInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.test(
        emailTestInputModel,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractEmailApi - factory interface
 * @export
 */
export const ContractEmailApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractEmailApiFp(configuration);
  return {
    /**
     *
     * @summary メールをテスト送信します。
     * @param {EmailTestInputModel} [emailTestInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    test(
      emailTestInputModel?: EmailTestInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .test(emailTestInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractEmailApi - object-oriented interface
 * @export
 * @class ContractEmailApi
 * @extends {BaseAPI}
 */
export class ContractEmailApi extends BaseAPI {
  /**
   *
   * @summary メールをテスト送信します。
   * @param {EmailTestInputModel} [emailTestInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractEmailApi
   */
  public test(
    emailTestInputModel?: EmailTestInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractEmailApiFp(this.configuration)
      .test(emailTestInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractInstalledApplicationApi - axios parameter creator
 * @export
 */
export const ContractInstalledApplicationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 連携アプリを作成します。
     * @param {CreateInstalledAppInputModel} [createInstalledAppInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInstalledAppAsync: async (
      createInstalledAppInputModel?: CreateInstalledAppInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/installed-applications`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInstalledAppInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 連携アプリを削除します。
     * @param {string} applicationId 連携を解除したいアプリのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInstalledAppAsync: async (
      applicationId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'applicationId' is not null or undefined
      assertParamExists(
        "deleteInstalledAppAsync",
        "applicationId",
        applicationId
      );
      const localVarPath =
        `/api/contract/installed-applications/{applicationId}`.replace(
          `{${"applicationId"}}`,
          encodeURIComponent(String(applicationId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 連携アプリの詳細を取得します。
     * @param {string} applicationId 詳細を取得したいアプリのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstalledAppDetailAsync: async (
      applicationId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'applicationId' is not null or undefined
      assertParamExists(
        "getInstalledAppDetailAsync",
        "applicationId",
        applicationId
      );
      const localVarPath =
        `/api/contract/installed-applications/{applicationId}`.replace(
          `{${"applicationId"}}`,
          encodeURIComponent(String(applicationId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 連携アプリの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstalledAppsAsync: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/installed-applications`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractInstalledApplicationApi - functional programming interface
 * @export
 */
export const ContractInstalledApplicationApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ContractInstalledApplicationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 連携アプリを作成します。
     * @param {CreateInstalledAppInputModel} [createInstalledAppInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createInstalledAppAsync(
      createInstalledAppInputModel?: CreateInstalledAppInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreateInstalledAppViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createInstalledAppAsync(
          createInstalledAppInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 連携アプリを削除します。
     * @param {string} applicationId 連携を解除したいアプリのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteInstalledAppAsync(
      applicationId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteInstalledAppAsync(
          applicationId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 連携アプリの詳細を取得します。
     * @param {string} applicationId 詳細を取得したいアプリのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInstalledAppDetailAsync(
      applicationId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetInstalledAppDetailViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getInstalledAppDetailAsync(
          applicationId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 連携アプリの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInstalledAppsAsync(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetInstalledAppsViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getInstalledAppsAsync(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractInstalledApplicationApi - factory interface
 * @export
 */
export const ContractInstalledApplicationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractInstalledApplicationApiFp(configuration);
  return {
    /**
     *
     * @summary 連携アプリを作成します。
     * @param {CreateInstalledAppInputModel} [createInstalledAppInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInstalledAppAsync(
      createInstalledAppInputModel?: CreateInstalledAppInputModel,
      options?: any
    ): AxiosPromise<CreateInstalledAppViewModel> {
      return localVarFp
        .createInstalledAppAsync(createInstalledAppInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 連携アプリを削除します。
     * @param {string} applicationId 連携を解除したいアプリのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInstalledAppAsync(
      applicationId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .deleteInstalledAppAsync(applicationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 連携アプリの詳細を取得します。
     * @param {string} applicationId 詳細を取得したいアプリのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstalledAppDetailAsync(
      applicationId: string,
      options?: any
    ): AxiosPromise<GetInstalledAppDetailViewModel> {
      return localVarFp
        .getInstalledAppDetailAsync(applicationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 連携アプリの一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstalledAppsAsync(
      options?: any
    ): AxiosPromise<GetInstalledAppsViewModel> {
      return localVarFp
        .getInstalledAppsAsync(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractInstalledApplicationApi - object-oriented interface
 * @export
 * @class ContractInstalledApplicationApi
 * @extends {BaseAPI}
 */
export class ContractInstalledApplicationApi extends BaseAPI {
  /**
   *
   * @summary 連携アプリを作成します。
   * @param {CreateInstalledAppInputModel} [createInstalledAppInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractInstalledApplicationApi
   */
  public createInstalledAppAsync(
    createInstalledAppInputModel?: CreateInstalledAppInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractInstalledApplicationApiFp(this.configuration)
      .createInstalledAppAsync(createInstalledAppInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 連携アプリを削除します。
   * @param {string} applicationId 連携を解除したいアプリのID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractInstalledApplicationApi
   */
  public deleteInstalledAppAsync(
    applicationId: string,
    options?: AxiosRequestConfig
  ) {
    return ContractInstalledApplicationApiFp(this.configuration)
      .deleteInstalledAppAsync(applicationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 連携アプリの詳細を取得します。
   * @param {string} applicationId 詳細を取得したいアプリのID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractInstalledApplicationApi
   */
  public getInstalledAppDetailAsync(
    applicationId: string,
    options?: AxiosRequestConfig
  ) {
    return ContractInstalledApplicationApiFp(this.configuration)
      .getInstalledAppDetailAsync(applicationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 連携アプリの一覧を取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractInstalledApplicationApi
   */
  public getInstalledAppsAsync(options?: AxiosRequestConfig) {
    return ContractInstalledApplicationApiFp(this.configuration)
      .getInstalledAppsAsync(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractLoginApi - axios parameter creator
 * @export
 */
export const ContractLoginApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 契約 ID とパスワードでログインします。
     * @param {ContractLoginInputModel} [contractLoginInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractLogin: async (
      contractLoginInputModel?: ContractLoginInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        contractLoginInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 認証コードでログインします。
     * @param {ContractLogin2faInputModel} [contractLogin2faInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractLogin2faAsync: async (
      contractLogin2faInputModel?: ContractLogin2faInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/login-2fa`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        contractLogin2faInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary リカバリーコードでログインします。
     * @param {ContractLoginRecoveryCodeInputModel} [contractLoginRecoveryCodeInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractLoginRecoveryCodeAsync: async (
      contractLoginRecoveryCodeInputModel?: ContractLoginRecoveryCodeInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/login-recovery-code`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        contractLoginRecoveryCodeInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractLoginApi - functional programming interface
 * @export
 */
export const ContractLoginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContractLoginApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 契約 ID とパスワードでログインします。
     * @param {ContractLoginInputModel} [contractLoginInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractLogin(
      contractLoginInputModel?: ContractLoginInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contractLogin(
        contractLoginInputModel,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 認証コードでログインします。
     * @param {ContractLogin2faInputModel} [contractLogin2faInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractLogin2faAsync(
      contractLogin2faInputModel?: ContractLogin2faInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractLogin2faAsync(
          contractLogin2faInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary リカバリーコードでログインします。
     * @param {ContractLoginRecoveryCodeInputModel} [contractLoginRecoveryCodeInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractLoginRecoveryCodeAsync(
      contractLoginRecoveryCodeInputModel?: ContractLoginRecoveryCodeInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractLoginRecoveryCodeAsync(
          contractLoginRecoveryCodeInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractLoginApi - factory interface
 * @export
 */
export const ContractLoginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractLoginApiFp(configuration);
  return {
    /**
     *
     * @summary 契約 ID とパスワードでログインします。
     * @param {ContractLoginInputModel} [contractLoginInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractLogin(
      contractLoginInputModel?: ContractLoginInputModel,
      options?: any
    ): AxiosPromise<TokenViewModel> {
      return localVarFp
        .contractLogin(contractLoginInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 認証コードでログインします。
     * @param {ContractLogin2faInputModel} [contractLogin2faInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractLogin2faAsync(
      contractLogin2faInputModel?: ContractLogin2faInputModel,
      options?: any
    ): AxiosPromise<TokenViewModel> {
      return localVarFp
        .contractLogin2faAsync(contractLogin2faInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary リカバリーコードでログインします。
     * @param {ContractLoginRecoveryCodeInputModel} [contractLoginRecoveryCodeInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractLoginRecoveryCodeAsync(
      contractLoginRecoveryCodeInputModel?: ContractLoginRecoveryCodeInputModel,
      options?: any
    ): AxiosPromise<TokenViewModel> {
      return localVarFp
        .contractLoginRecoveryCodeAsync(
          contractLoginRecoveryCodeInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractLoginApi - object-oriented interface
 * @export
 * @class ContractLoginApi
 * @extends {BaseAPI}
 */
export class ContractLoginApi extends BaseAPI {
  /**
   *
   * @summary 契約 ID とパスワードでログインします。
   * @param {ContractLoginInputModel} [contractLoginInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractLoginApi
   */
  public contractLogin(
    contractLoginInputModel?: ContractLoginInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractLoginApiFp(this.configuration)
      .contractLogin(contractLoginInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 認証コードでログインします。
   * @param {ContractLogin2faInputModel} [contractLogin2faInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractLoginApi
   */
  public contractLogin2faAsync(
    contractLogin2faInputModel?: ContractLogin2faInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractLoginApiFp(this.configuration)
      .contractLogin2faAsync(contractLogin2faInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary リカバリーコードでログインします。
   * @param {ContractLoginRecoveryCodeInputModel} [contractLoginRecoveryCodeInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractLoginApi
   */
  public contractLoginRecoveryCodeAsync(
    contractLoginRecoveryCodeInputModel?: ContractLoginRecoveryCodeInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractLoginApiFp(this.configuration)
      .contractLoginRecoveryCodeAsync(
        contractLoginRecoveryCodeInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractLogsApi - axios parameter creator
 * @export
 */
export const ContractLogsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 操作ログ一を登録します。
     * @param {ContractLogInputModel} [contractLogInputModel] 登録する操作ログ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createContractLog: async (
      contractLogInputModel?: ContractLogInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/logs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        contractLogInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 操作ログ一覧を取得します。
     * @param {number} [page] ページ番号(0 ～)
     * @param {number} [perPage] ページに表示する件数(1 ～)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractLogs: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/logs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (page !== undefined) {
        localVarQueryParameter["Page"] = page;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["PerPage"] = perPage;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractLogsApi - functional programming interface
 * @export
 */
export const ContractLogsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContractLogsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 操作ログ一を登録します。
     * @param {ContractLogInputModel} [contractLogInputModel] 登録する操作ログ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createContractLog(
      contractLogInputModel?: ContractLogInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractLogViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createContractLog(
          contractLogInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 操作ログ一覧を取得します。
     * @param {number} [page] ページ番号(0 ～)
     * @param {number} [perPage] ページに表示する件数(1 ～)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listContractLogs(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractLogsViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listContractLogs(
          page,
          perPage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractLogsApi - factory interface
 * @export
 */
export const ContractLogsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractLogsApiFp(configuration);
  return {
    /**
     *
     * @summary 操作ログ一を登録します。
     * @param {ContractLogInputModel} [contractLogInputModel] 登録する操作ログ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createContractLog(
      contractLogInputModel?: ContractLogInputModel,
      options?: any
    ): AxiosPromise<ContractLogViewModel> {
      return localVarFp
        .createContractLog(contractLogInputModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 操作ログ一覧を取得します。
     * @param {number} [page] ページ番号(0 ～)
     * @param {number} [perPage] ページに表示する件数(1 ～)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractLogs(
      page?: number,
      perPage?: number,
      options?: any
    ): AxiosPromise<ContractLogsViewModel> {
      return localVarFp
        .listContractLogs(page, perPage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractLogsApi - object-oriented interface
 * @export
 * @class ContractLogsApi
 * @extends {BaseAPI}
 */
export class ContractLogsApi extends BaseAPI {
  /**
   *
   * @summary 操作ログ一を登録します。
   * @param {ContractLogInputModel} [contractLogInputModel] 登録する操作ログ
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractLogsApi
   */
  public createContractLog(
    contractLogInputModel?: ContractLogInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractLogsApiFp(this.configuration)
      .createContractLog(contractLogInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 操作ログ一覧を取得します。
   * @param {number} [page] ページ番号(0 ～)
   * @param {number} [perPage] ページに表示する件数(1 ～)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractLogsApi
   */
  public listContractLogs(
    page?: number,
    perPage?: number,
    options?: AxiosRequestConfig
  ) {
    return ContractLogsApiFp(this.configuration)
      .listContractLogs(page, perPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractProductsApi - axios parameter creator
 * @export
 */
export const ContractProductsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 契約している製品の WebHook イベントの一覧を取得します。
     * @param {string} productId 製品 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractProductHookEvents: async (
      productId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists(
        "listContractProductHookEvents",
        "productId",
        productId
      );
      const localVarPath =
        `/api/contract/products/{productId}/hook/events`.replace(
          `{${"productId"}}`,
          encodeURIComponent(String(productId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 組織に紐づくテナントが利用している製品の一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractProducts: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/products`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 組織に紐づくテナントが利用している製品をアップグレードします。
     * @param {string} productId 製品 ID
     * @param {UpgradeProductInputModel} [upgradeProductInputModel] 製品のアップグレード情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upgradeContractProduct: async (
      productId: string,
      upgradeProductInputModel?: UpgradeProductInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("upgradeContractProduct", "productId", productId);
      const localVarPath = `/api/contract/products/{productId}/version`.replace(
        `{${"productId"}}`,
        encodeURIComponent(String(productId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upgradeProductInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractProductsApi - functional programming interface
 * @export
 */
export const ContractProductsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContractProductsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 契約している製品の WebHook イベントの一覧を取得します。
     * @param {string} productId 製品 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listContractProductHookEvents(
      productId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<HookEventViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listContractProductHookEvents(
          productId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 組織に紐づくテナントが利用している製品の一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listContractProducts(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ContractProductViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listContractProducts(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 組織に紐づくテナントが利用している製品をアップグレードします。
     * @param {string} productId 製品 ID
     * @param {UpgradeProductInputModel} [upgradeProductInputModel] 製品のアップグレード情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upgradeContractProduct(
      productId: string,
      upgradeProductInputModel?: UpgradeProductInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.upgradeContractProduct(
          productId,
          upgradeProductInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractProductsApi - factory interface
 * @export
 */
export const ContractProductsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractProductsApiFp(configuration);
  return {
    /**
     *
     * @summary 契約している製品の WebHook イベントの一覧を取得します。
     * @param {string} productId 製品 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractProductHookEvents(
      productId: string,
      options?: any
    ): AxiosPromise<Array<HookEventViewModel>> {
      return localVarFp
        .listContractProductHookEvents(productId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 組織に紐づくテナントが利用している製品の一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContractProducts(
      options?: any
    ): AxiosPromise<Array<ContractProductViewModel>> {
      return localVarFp
        .listContractProducts(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 組織に紐づくテナントが利用している製品をアップグレードします。
     * @param {string} productId 製品 ID
     * @param {UpgradeProductInputModel} [upgradeProductInputModel] 製品のアップグレード情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upgradeContractProduct(
      productId: string,
      upgradeProductInputModel?: UpgradeProductInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .upgradeContractProduct(productId, upgradeProductInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractProductsApi - object-oriented interface
 * @export
 * @class ContractProductsApi
 * @extends {BaseAPI}
 */
export class ContractProductsApi extends BaseAPI {
  /**
   *
   * @summary 契約している製品の WebHook イベントの一覧を取得します。
   * @param {string} productId 製品 ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractProductsApi
   */
  public listContractProductHookEvents(
    productId: string,
    options?: AxiosRequestConfig
  ) {
    return ContractProductsApiFp(this.configuration)
      .listContractProductHookEvents(productId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 組織に紐づくテナントが利用している製品の一覧を取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractProductsApi
   */
  public listContractProducts(options?: AxiosRequestConfig) {
    return ContractProductsApiFp(this.configuration)
      .listContractProducts(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 組織に紐づくテナントが利用している製品をアップグレードします。
   * @param {string} productId 製品 ID
   * @param {UpgradeProductInputModel} [upgradeProductInputModel] 製品のアップグレード情報
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractProductsApi
   */
  public upgradeContractProduct(
    productId: string,
    upgradeProductInputModel?: UpgradeProductInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractProductsApiFp(this.configuration)
      .upgradeContractProduct(productId, upgradeProductInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractTenantApi - axios parameter creator
 * @export
 */
export const ContractTenantApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 大臣AXクラウドのパスワードポリシーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPasswordPolicy: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/tenant/password-policy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 大臣AXクラウドのシステム管理者のパスワードをリセットします。
     * @param {ResetAdministratorPasswordInputModel} [resetAdministratorPasswordInputModel] 新しいパスワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetAdministratorPassword: async (
      resetAdministratorPasswordInputModel?: ResetAdministratorPasswordInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/contract/tenant/accounts/administrator/password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resetAdministratorPasswordInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractTenantApi - functional programming interface
 * @export
 */
export const ContractTenantApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContractTenantApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 大臣AXクラウドのパスワードポリシーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPasswordPolicy(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PasswordPolicyViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPasswordPolicy(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 大臣AXクラウドのシステム管理者のパスワードをリセットします。
     * @param {ResetAdministratorPasswordInputModel} [resetAdministratorPasswordInputModel] 新しいパスワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetAdministratorPassword(
      resetAdministratorPasswordInputModel?: ResetAdministratorPasswordInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.resetAdministratorPassword(
          resetAdministratorPasswordInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractTenantApi - factory interface
 * @export
 */
export const ContractTenantApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractTenantApiFp(configuration);
  return {
    /**
     *
     * @summary 大臣AXクラウドのパスワードポリシーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPasswordPolicy(options?: any): AxiosPromise<PasswordPolicyViewModel> {
      return localVarFp
        .getPasswordPolicy(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 大臣AXクラウドのシステム管理者のパスワードをリセットします。
     * @param {ResetAdministratorPasswordInputModel} [resetAdministratorPasswordInputModel] 新しいパスワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetAdministratorPassword(
      resetAdministratorPasswordInputModel?: ResetAdministratorPasswordInputModel,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .resetAdministratorPassword(
          resetAdministratorPasswordInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractTenantApi - object-oriented interface
 * @export
 * @class ContractTenantApi
 * @extends {BaseAPI}
 */
export class ContractTenantApi extends BaseAPI {
  /**
   *
   * @summary 大臣AXクラウドのパスワードポリシーを取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractTenantApi
   */
  public getPasswordPolicy(options?: AxiosRequestConfig) {
    return ContractTenantApiFp(this.configuration)
      .getPasswordPolicy(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 大臣AXクラウドのシステム管理者のパスワードをリセットします。
   * @param {ResetAdministratorPasswordInputModel} [resetAdministratorPasswordInputModel] 新しいパスワード
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractTenantApi
   */
  public resetAdministratorPassword(
    resetAdministratorPasswordInputModel?: ResetAdministratorPasswordInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractTenantApiFp(this.configuration)
      .resetAdministratorPassword(resetAdministratorPasswordInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractsApi - axios parameter creator
 * @export
 */
export const ContractsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 大臣AXクラウドを解約します。
     * @param {string} contractId 契約 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelContract: async (
      contractId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractId' is not null or undefined
      assertParamExists("cancelContract", "contractId", contractId);
      const localVarPath =
        `/api/admin/contracts/{contractId}/cancelled`.replace(
          `{${"contractId"}}`,
          encodeURIComponent(String(contractId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 解約された大臣 AX クラウドの契約一覧を取得します。
     * @param {string} [contractId] 契約 ID
     * @param {string} [cancelledAtGte] 指定した解約日時以降
     * @param {string} [cancelledAtLte] 指定した解約日時以前
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCancelledContracts: async (
      contractId?: string,
      cancelledAtGte?: string,
      cancelledAtLte?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/admin/contracts/cancelled`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (contractId !== undefined) {
        localVarQueryParameter["ContractId"] = contractId;
      }

      if (cancelledAtGte !== undefined) {
        localVarQueryParameter["CancelledAt__gte"] =
          (cancelledAtGte as any) instanceof Date
            ? (cancelledAtGte as any).toISOString()
            : cancelledAtGte;
      }

      if (cancelledAtLte !== undefined) {
        localVarQueryParameter["CancelledAt__lte"] =
          (cancelledAtLte as any) instanceof Date
            ? (cancelledAtLte as any).toISOString()
            : cancelledAtLte;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 契約情報を取得します。
     * @param {string} contractId 契約 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContractById: async (
      contractId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractId' is not null or undefined
      assertParamExists("getContractById", "contractId", contractId);
      const localVarPath = `/api/admin/contracts/{contractId}`.replace(
        `{${"contractId"}}`,
        encodeURIComponent(String(contractId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 契約情報を更新します。
     * @param {string} contractId 契約 ID
     * @param {UpdateContractInputModel} [updateContractInputModel] 契約情報の更新内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContract: async (
      contractId: string,
      updateContractInputModel?: UpdateContractInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractId' is not null or undefined
      assertParamExists("updateContract", "contractId", contractId);
      const localVarPath = `/api/admin/contracts/{contractId}`.replace(
        `{${"contractId"}}`,
        encodeURIComponent(String(contractId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateContractInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractsApi - functional programming interface
 * @export
 */
export const ContractsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContractsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 大臣AXクラウドを解約します。
     * @param {string} contractId 契約 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelContract(
      contractId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelContract(
        contractId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 解約された大臣 AX クラウドの契約一覧を取得します。
     * @param {string} [contractId] 契約 ID
     * @param {string} [cancelledAtGte] 指定した解約日時以降
     * @param {string} [cancelledAtLte] 指定した解約日時以前
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCancelledContracts(
      contractId?: string,
      cancelledAtGte?: string,
      cancelledAtLte?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CancelledContractViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCancelledContracts(
          contractId,
          cancelledAtGte,
          cancelledAtLte,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 契約情報を取得します。
     * @param {string} contractId 契約 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContractById(
      contractId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractDetailsViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getContractById(
        contractId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 契約情報を更新します。
     * @param {string} contractId 契約 ID
     * @param {UpdateContractInputModel} [updateContractInputModel] 契約情報の更新内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateContract(
      contractId: string,
      updateContractInputModel?: UpdateContractInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractDetailsViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateContract(
        contractId,
        updateContractInputModel,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContractsApi - factory interface
 * @export
 */
export const ContractsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractsApiFp(configuration);
  return {
    /**
     *
     * @summary 大臣AXクラウドを解約します。
     * @param {string} contractId 契約 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelContract(contractId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .cancelContract(contractId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 解約された大臣 AX クラウドの契約一覧を取得します。
     * @param {string} [contractId] 契約 ID
     * @param {string} [cancelledAtGte] 指定した解約日時以降
     * @param {string} [cancelledAtLte] 指定した解約日時以前
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCancelledContracts(
      contractId?: string,
      cancelledAtGte?: string,
      cancelledAtLte?: string,
      options?: any
    ): AxiosPromise<Array<CancelledContractViewModel>> {
      return localVarFp
        .getCancelledContracts(
          contractId,
          cancelledAtGte,
          cancelledAtLte,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 契約情報を取得します。
     * @param {string} contractId 契約 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContractById(
      contractId: string,
      options?: any
    ): AxiosPromise<ContractDetailsViewModel> {
      return localVarFp
        .getContractById(contractId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 契約情報を更新します。
     * @param {string} contractId 契約 ID
     * @param {UpdateContractInputModel} [updateContractInputModel] 契約情報の更新内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContract(
      contractId: string,
      updateContractInputModel?: UpdateContractInputModel,
      options?: any
    ): AxiosPromise<ContractDetailsViewModel> {
      return localVarFp
        .updateContract(contractId, updateContractInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractsApi - object-oriented interface
 * @export
 * @class ContractsApi
 * @extends {BaseAPI}
 */
export class ContractsApi extends BaseAPI {
  /**
   *
   * @summary 大臣AXクラウドを解約します。
   * @param {string} contractId 契約 ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractsApi
   */
  public cancelContract(contractId: string, options?: AxiosRequestConfig) {
    return ContractsApiFp(this.configuration)
      .cancelContract(contractId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 解約された大臣 AX クラウドの契約一覧を取得します。
   * @param {string} [contractId] 契約 ID
   * @param {string} [cancelledAtGte] 指定した解約日時以降
   * @param {string} [cancelledAtLte] 指定した解約日時以前
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractsApi
   */
  public getCancelledContracts(
    contractId?: string,
    cancelledAtGte?: string,
    cancelledAtLte?: string,
    options?: AxiosRequestConfig
  ) {
    return ContractsApiFp(this.configuration)
      .getCancelledContracts(
        contractId,
        cancelledAtGte,
        cancelledAtLte,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 契約情報を取得します。
   * @param {string} contractId 契約 ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractsApi
   */
  public getContractById(contractId: string, options?: AxiosRequestConfig) {
    return ContractsApiFp(this.configuration)
      .getContractById(contractId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 契約情報を更新します。
   * @param {string} contractId 契約 ID
   * @param {UpdateContractInputModel} [updateContractInputModel] 契約情報の更新内容
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractsApi
   */
  public updateContract(
    contractId: string,
    updateContractInputModel?: UpdateContractInputModel,
    options?: AxiosRequestConfig
  ) {
    return ContractsApiFp(this.configuration)
      .updateContract(contractId, updateContractInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ManagementToolsApi - axios parameter creator
 * @export
 */
export const ManagementToolsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Body:     {    \"version\": 必須,    \"ipAddress\": 必須   }
     * @summary 管理ツールバージョンを登録します。
     * @param {ManagementToolCreateInputModel} [managementToolCreateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createManagementToolVersionAsync: async (
      managementToolCreateInputModel?: ManagementToolCreateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/admin/management-tools`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        managementToolCreateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 管理ツールバージョン一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getManagementToolVersionsAsync: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/admin/management-tools`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Body:     {    \"ipAddress\": 必須   }
     * @summary 管理ツールを更新します。
     * @param {string} version
     * @param {ManagementToolUpdateInputModel} [managementToolUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateManagementToolAsync: async (
      version: string,
      managementToolUpdateInputModel?: ManagementToolUpdateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'version' is not null or undefined
      assertParamExists("updateManagementToolAsync", "version", version);
      const localVarPath = `/api/admin/management-tools/{version}`.replace(
        `{${"version"}}`,
        encodeURIComponent(String(version))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        managementToolUpdateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ManagementToolsApi - functional programming interface
 * @export
 */
export const ManagementToolsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ManagementToolsApiAxiosParamCreator(configuration);
  return {
    /**
     * Body:     {    \"version\": 必須,    \"ipAddress\": 必須   }
     * @summary 管理ツールバージョンを登録します。
     * @param {ManagementToolCreateInputModel} [managementToolCreateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createManagementToolVersionAsync(
      managementToolCreateInputModel?: ManagementToolCreateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ManagementToolVersionViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createManagementToolVersionAsync(
          managementToolCreateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 管理ツールバージョン一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getManagementToolVersionsAsync(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ManagementToolVersionViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getManagementToolVersionsAsync(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Body:     {    \"ipAddress\": 必須   }
     * @summary 管理ツールを更新します。
     * @param {string} version
     * @param {ManagementToolUpdateInputModel} [managementToolUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateManagementToolAsync(
      version: string,
      managementToolUpdateInputModel?: ManagementToolUpdateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ManagementToolUpdateViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateManagementToolAsync(
          version,
          managementToolUpdateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ManagementToolsApi - factory interface
 * @export
 */
export const ManagementToolsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ManagementToolsApiFp(configuration);
  return {
    /**
     * Body:     {    \"version\": 必須,    \"ipAddress\": 必須   }
     * @summary 管理ツールバージョンを登録します。
     * @param {ManagementToolCreateInputModel} [managementToolCreateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createManagementToolVersionAsync(
      managementToolCreateInputModel?: ManagementToolCreateInputModel,
      options?: any
    ): AxiosPromise<ManagementToolVersionViewModel> {
      return localVarFp
        .createManagementToolVersionAsync(
          managementToolCreateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 管理ツールバージョン一覧を取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getManagementToolVersionsAsync(
      options?: any
    ): AxiosPromise<Array<ManagementToolVersionViewModel>> {
      return localVarFp
        .getManagementToolVersionsAsync(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Body:     {    \"ipAddress\": 必須   }
     * @summary 管理ツールを更新します。
     * @param {string} version
     * @param {ManagementToolUpdateInputModel} [managementToolUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateManagementToolAsync(
      version: string,
      managementToolUpdateInputModel?: ManagementToolUpdateInputModel,
      options?: any
    ): AxiosPromise<ManagementToolUpdateViewModel> {
      return localVarFp
        .updateManagementToolAsync(
          version,
          managementToolUpdateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ManagementToolsApi - object-oriented interface
 * @export
 * @class ManagementToolsApi
 * @extends {BaseAPI}
 */
export class ManagementToolsApi extends BaseAPI {
  /**
   * Body:     {    \"version\": 必須,    \"ipAddress\": 必須   }
   * @summary 管理ツールバージョンを登録します。
   * @param {ManagementToolCreateInputModel} [managementToolCreateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ManagementToolsApi
   */
  public createManagementToolVersionAsync(
    managementToolCreateInputModel?: ManagementToolCreateInputModel,
    options?: AxiosRequestConfig
  ) {
    return ManagementToolsApiFp(this.configuration)
      .createManagementToolVersionAsync(managementToolCreateInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 管理ツールバージョン一覧を取得します。
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ManagementToolsApi
   */
  public getManagementToolVersionsAsync(options?: AxiosRequestConfig) {
    return ManagementToolsApiFp(this.configuration)
      .getManagementToolVersionsAsync(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Body:     {    \"ipAddress\": 必須   }
   * @summary 管理ツールを更新します。
   * @param {string} version
   * @param {ManagementToolUpdateInputModel} [managementToolUpdateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ManagementToolsApi
   */
  public updateManagementToolAsync(
    version: string,
    managementToolUpdateInputModel?: ManagementToolUpdateInputModel,
    options?: AxiosRequestConfig
  ) {
    return ManagementToolsApiFp(this.configuration)
      .updateManagementToolAsync(
        version,
        managementToolUpdateInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProductApiApi - axios parameter creator
 * @export
 */
export const ProductApiApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Body:     {    \"loadBalancerIpAddress\": 必須   }
     * @summary 新しい製品APIを登録します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductApiRegisterInputModel} [productApiRegisterInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerProductApiAsync: async (
      productId: string,
      version: string,
      productApiRegisterInputModel?: ProductApiRegisterInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("registerProductApiAsync", "productId", productId);
      // verify required parameter 'version' is not null or undefined
      assertParamExists("registerProductApiAsync", "version", version);
      const localVarPath =
        `/api/admin/products/{productId}/versions/{version}/api`
          .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
          .replace(`{${"version"}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productApiRegisterInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Body:     {    \"loadBalancerIpAddress\": 必須   }
     * @summary 製品APIを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductApiUpdateInputModel} [productApiUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProductApiAsync: async (
      productId: string,
      version: string,
      productApiUpdateInputModel?: ProductApiUpdateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("updateProductApiAsync", "productId", productId);
      // verify required parameter 'version' is not null or undefined
      assertParamExists("updateProductApiAsync", "version", version);
      const localVarPath =
        `/api/admin/products/{productId}/versions/{version}/api`
          .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
          .replace(`{${"version"}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productApiUpdateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProductApiApi - functional programming interface
 * @export
 */
export const ProductApiApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ProductApiApiAxiosParamCreator(configuration);
  return {
    /**
     * Body:     {    \"loadBalancerIpAddress\": 必須   }
     * @summary 新しい製品APIを登録します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductApiRegisterInputModel} [productApiRegisterInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registerProductApiAsync(
      productId: string,
      version: string,
      productApiRegisterInputModel?: ProductApiRegisterInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ProductApiRegisterViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registerProductApiAsync(
          productId,
          version,
          productApiRegisterInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Body:     {    \"loadBalancerIpAddress\": 必須   }
     * @summary 製品APIを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductApiUpdateInputModel} [productApiUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProductApiAsync(
      productId: string,
      version: string,
      productApiUpdateInputModel?: ProductApiUpdateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ProductApiUpdateViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateProductApiAsync(
          productId,
          version,
          productApiUpdateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ProductApiApi - factory interface
 * @export
 */
export const ProductApiApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProductApiApiFp(configuration);
  return {
    /**
     * Body:     {    \"loadBalancerIpAddress\": 必須   }
     * @summary 新しい製品APIを登録します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductApiRegisterInputModel} [productApiRegisterInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerProductApiAsync(
      productId: string,
      version: string,
      productApiRegisterInputModel?: ProductApiRegisterInputModel,
      options?: any
    ): AxiosPromise<ProductApiRegisterViewModel> {
      return localVarFp
        .registerProductApiAsync(
          productId,
          version,
          productApiRegisterInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Body:     {    \"loadBalancerIpAddress\": 必須   }
     * @summary 製品APIを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductApiUpdateInputModel} [productApiUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProductApiAsync(
      productId: string,
      version: string,
      productApiUpdateInputModel?: ProductApiUpdateInputModel,
      options?: any
    ): AxiosPromise<ProductApiUpdateViewModel> {
      return localVarFp
        .updateProductApiAsync(
          productId,
          version,
          productApiUpdateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProductApiApi - object-oriented interface
 * @export
 * @class ProductApiApi
 * @extends {BaseAPI}
 */
export class ProductApiApi extends BaseAPI {
  /**
   * Body:     {    \"loadBalancerIpAddress\": 必須   }
   * @summary 新しい製品APIを登録します。
   * @param {string} productId
   * @param {string} version
   * @param {ProductApiRegisterInputModel} [productApiRegisterInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductApiApi
   */
  public registerProductApiAsync(
    productId: string,
    version: string,
    productApiRegisterInputModel?: ProductApiRegisterInputModel,
    options?: AxiosRequestConfig
  ) {
    return ProductApiApiFp(this.configuration)
      .registerProductApiAsync(
        productId,
        version,
        productApiRegisterInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Body:     {    \"loadBalancerIpAddress\": 必須   }
   * @summary 製品APIを更新します。
   * @param {string} productId
   * @param {string} version
   * @param {ProductApiUpdateInputModel} [productApiUpdateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductApiApi
   */
  public updateProductApiAsync(
    productId: string,
    version: string,
    productApiUpdateInputModel?: ProductApiUpdateInputModel,
    options?: AxiosRequestConfig
  ) {
    return ProductApiApiFp(this.configuration)
      .updateProductApiAsync(
        productId,
        version,
        productApiUpdateInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProductVersionsApi - axios parameter creator
 * @export
 */
export const ProductVersionsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * 製品バージョンを使用しているテナントがいる場合は削除できません。
     * @summary 製品のバージョンを削除します。
     * @param {string} productId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProductVersionAsync: async (
      productId: string,
      version: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("deleteProductVersionAsync", "productId", productId);
      // verify required parameter 'version' is not null or undefined
      assertParamExists("deleteProductVersionAsync", "version", version);
      const localVarPath = `/api/admin/products/{productId}/versions/{version}`
        .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
        .replace(`{${"version"}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 製品バージョンの一覧を取得します。
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductVersionsAsync: async (
      productId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("getProductVersionsAsync", "productId", productId);
      const localVarPath = `/api/admin/products/{productId}/versions`.replace(
        `{${"productId"}}`,
        encodeURIComponent(String(productId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 製品バージョンを公開します。
     * @param {string} productId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publishProductVersionAsync: async (
      productId: string,
      version: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("publishProductVersionAsync", "productId", productId);
      // verify required parameter 'version' is not null or undefined
      assertParamExists("publishProductVersionAsync", "version", version);
      const localVarPath =
        `/api/admin/products/{productId}/versions/{version}/publish`
          .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
          .replace(`{${"version"}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Body:     {    \"productVersion\": 必須,    \"managementToolVersion\": 必須,    \"ipAddress\": 必須,    \"isPrivate\": オプション,    \"manualUrl\": オプション,    \"updateDeadLine\": オプション   }
     * @summary 新しい製品バージョンを登録します。
     * @param {string} productId
     * @param {ProductVersionRegisterInputModel} [productVersionRegisterInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerProductVersionAsync: async (
      productId: string,
      productVersionRegisterInputModel?: ProductVersionRegisterInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("registerProductVersionAsync", "productId", productId);
      const localVarPath = `/api/admin/products/{productId}/versions`.replace(
        `{${"productId"}}`,
        encodeURIComponent(String(productId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productVersionRegisterInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Body:     {    \"ipAddress\": 必須   }
     * @summary 製品のバージョンを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductVersionUpdateInputModel} [productVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProductVersionAsync: async (
      productId: string,
      version: string,
      productVersionUpdateInputModel?: ProductVersionUpdateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("updateProductVersionAsync", "productId", productId);
      // verify required parameter 'version' is not null or undefined
      assertParamExists("updateProductVersionAsync", "version", version);
      const localVarPath = `/api/admin/products/{productId}/versions/{version}`
        .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
        .replace(`{${"version"}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productVersionUpdateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Body:     {    \"managementToolsVersion\": 必須   }
     * @summary 製品の管理ツールバージョンを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductVersionManagementToolsVersionUpdateInputModel} [productVersionManagementToolsVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProductVersionManagementToolsVersionAsync: async (
      productId: string,
      version: string,
      productVersionManagementToolsVersionUpdateInputModel?: ProductVersionManagementToolsVersionUpdateInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists(
        "updateProductVersionManagementToolsVersionAsync",
        "productId",
        productId
      );
      // verify required parameter 'version' is not null or undefined
      assertParamExists(
        "updateProductVersionManagementToolsVersionAsync",
        "version",
        version
      );
      const localVarPath =
        `/api/admin/products/{productId}/versions/{version}/management-tools-version`
          .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
          .replace(`{${"version"}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productVersionManagementToolsVersionUpdateInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProductVersionsApi - functional programming interface
 * @export
 */
export const ProductVersionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ProductVersionsApiAxiosParamCreator(configuration);
  return {
    /**
     * 製品バージョンを使用しているテナントがいる場合は削除できません。
     * @summary 製品のバージョンを削除します。
     * @param {string} productId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteProductVersionAsync(
      productId: string,
      version: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteProductVersionAsync(
          productId,
          version,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 製品バージョンの一覧を取得します。
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductVersionsAsync(
      productId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ProductVersionViewModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getProductVersionsAsync(
          productId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary 製品バージョンを公開します。
     * @param {string} productId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publishProductVersionAsync(
      productId: string,
      version: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.publishProductVersionAsync(
          productId,
          version,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Body:     {    \"productVersion\": 必須,    \"managementToolVersion\": 必須,    \"ipAddress\": 必須,    \"isPrivate\": オプション,    \"manualUrl\": オプション,    \"updateDeadLine\": オプション   }
     * @summary 新しい製品バージョンを登録します。
     * @param {string} productId
     * @param {ProductVersionRegisterInputModel} [productVersionRegisterInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registerProductVersionAsync(
      productId: string,
      productVersionRegisterInputModel?: ProductVersionRegisterInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ProductVersionRegisterViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registerProductVersionAsync(
          productId,
          productVersionRegisterInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Body:     {    \"ipAddress\": 必須   }
     * @summary 製品のバージョンを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductVersionUpdateInputModel} [productVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProductVersionAsync(
      productId: string,
      version: string,
      productVersionUpdateInputModel?: ProductVersionUpdateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ProductVersionUpdateViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateProductVersionAsync(
          productId,
          version,
          productVersionUpdateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Body:     {    \"managementToolsVersion\": 必須   }
     * @summary 製品の管理ツールバージョンを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductVersionManagementToolsVersionUpdateInputModel} [productVersionManagementToolsVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProductVersionManagementToolsVersionAsync(
      productId: string,
      version: string,
      productVersionManagementToolsVersionUpdateInputModel?: ProductVersionManagementToolsVersionUpdateInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ProductVersionUpdateViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateProductVersionManagementToolsVersionAsync(
          productId,
          version,
          productVersionManagementToolsVersionUpdateInputModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ProductVersionsApi - factory interface
 * @export
 */
export const ProductVersionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProductVersionsApiFp(configuration);
  return {
    /**
     * 製品バージョンを使用しているテナントがいる場合は削除できません。
     * @summary 製品のバージョンを削除します。
     * @param {string} productId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProductVersionAsync(
      productId: string,
      version: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .deleteProductVersionAsync(productId, version, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 製品バージョンの一覧を取得します。
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductVersionsAsync(
      productId: string,
      options?: any
    ): AxiosPromise<Array<ProductVersionViewModel>> {
      return localVarFp
        .getProductVersionsAsync(productId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 製品バージョンを公開します。
     * @param {string} productId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publishProductVersionAsync(
      productId: string,
      version: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .publishProductVersionAsync(productId, version, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Body:     {    \"productVersion\": 必須,    \"managementToolVersion\": 必須,    \"ipAddress\": 必須,    \"isPrivate\": オプション,    \"manualUrl\": オプション,    \"updateDeadLine\": オプション   }
     * @summary 新しい製品バージョンを登録します。
     * @param {string} productId
     * @param {ProductVersionRegisterInputModel} [productVersionRegisterInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerProductVersionAsync(
      productId: string,
      productVersionRegisterInputModel?: ProductVersionRegisterInputModel,
      options?: any
    ): AxiosPromise<ProductVersionRegisterViewModel> {
      return localVarFp
        .registerProductVersionAsync(
          productId,
          productVersionRegisterInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Body:     {    \"ipAddress\": 必須   }
     * @summary 製品のバージョンを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductVersionUpdateInputModel} [productVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProductVersionAsync(
      productId: string,
      version: string,
      productVersionUpdateInputModel?: ProductVersionUpdateInputModel,
      options?: any
    ): AxiosPromise<ProductVersionUpdateViewModel> {
      return localVarFp
        .updateProductVersionAsync(
          productId,
          version,
          productVersionUpdateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Body:     {    \"managementToolsVersion\": 必須   }
     * @summary 製品の管理ツールバージョンを更新します。
     * @param {string} productId
     * @param {string} version
     * @param {ProductVersionManagementToolsVersionUpdateInputModel} [productVersionManagementToolsVersionUpdateInputModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProductVersionManagementToolsVersionAsync(
      productId: string,
      version: string,
      productVersionManagementToolsVersionUpdateInputModel?: ProductVersionManagementToolsVersionUpdateInputModel,
      options?: any
    ): AxiosPromise<ProductVersionUpdateViewModel> {
      return localVarFp
        .updateProductVersionManagementToolsVersionAsync(
          productId,
          version,
          productVersionManagementToolsVersionUpdateInputModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProductVersionsApi - object-oriented interface
 * @export
 * @class ProductVersionsApi
 * @extends {BaseAPI}
 */
export class ProductVersionsApi extends BaseAPI {
  /**
   * 製品バージョンを使用しているテナントがいる場合は削除できません。
   * @summary 製品のバージョンを削除します。
   * @param {string} productId
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductVersionsApi
   */
  public deleteProductVersionAsync(
    productId: string,
    version: string,
    options?: AxiosRequestConfig
  ) {
    return ProductVersionsApiFp(this.configuration)
      .deleteProductVersionAsync(productId, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 製品バージョンの一覧を取得します。
   * @param {string} productId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductVersionsApi
   */
  public getProductVersionsAsync(
    productId: string,
    options?: AxiosRequestConfig
  ) {
    return ProductVersionsApiFp(this.configuration)
      .getProductVersionsAsync(productId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 製品バージョンを公開します。
   * @param {string} productId
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductVersionsApi
   */
  public publishProductVersionAsync(
    productId: string,
    version: string,
    options?: AxiosRequestConfig
  ) {
    return ProductVersionsApiFp(this.configuration)
      .publishProductVersionAsync(productId, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Body:     {    \"productVersion\": 必須,    \"managementToolVersion\": 必須,    \"ipAddress\": 必須,    \"isPrivate\": オプション,    \"manualUrl\": オプション,    \"updateDeadLine\": オプション   }
   * @summary 新しい製品バージョンを登録します。
   * @param {string} productId
   * @param {ProductVersionRegisterInputModel} [productVersionRegisterInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductVersionsApi
   */
  public registerProductVersionAsync(
    productId: string,
    productVersionRegisterInputModel?: ProductVersionRegisterInputModel,
    options?: AxiosRequestConfig
  ) {
    return ProductVersionsApiFp(this.configuration)
      .registerProductVersionAsync(
        productId,
        productVersionRegisterInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Body:     {    \"ipAddress\": 必須   }
   * @summary 製品のバージョンを更新します。
   * @param {string} productId
   * @param {string} version
   * @param {ProductVersionUpdateInputModel} [productVersionUpdateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductVersionsApi
   */
  public updateProductVersionAsync(
    productId: string,
    version: string,
    productVersionUpdateInputModel?: ProductVersionUpdateInputModel,
    options?: AxiosRequestConfig
  ) {
    return ProductVersionsApiFp(this.configuration)
      .updateProductVersionAsync(
        productId,
        version,
        productVersionUpdateInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Body:     {    \"managementToolsVersion\": 必須   }
   * @summary 製品の管理ツールバージョンを更新します。
   * @param {string} productId
   * @param {string} version
   * @param {ProductVersionManagementToolsVersionUpdateInputModel} [productVersionManagementToolsVersionUpdateInputModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductVersionsApi
   */
  public updateProductVersionManagementToolsVersionAsync(
    productId: string,
    version: string,
    productVersionManagementToolsVersionUpdateInputModel?: ProductVersionManagementToolsVersionUpdateInputModel,
    options?: AxiosRequestConfig
  ) {
    return ProductVersionsApiFp(this.configuration)
      .updateProductVersionManagementToolsVersionAsync(
        productId,
        version,
        productVersionManagementToolsVersionUpdateInputModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * StoragesApi - axios parameter creator
 * @export
 */
export const StoragesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 契約IDよりストレージ情報を取得します。
     * @param {string} contractId 契約ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStoragesByContractId: async (
      contractId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractId' is not null or undefined
      assertParamExists("getStoragesByContractId", "contractId", contractId);
      const localVarPath = `/api/admin/storages/{contractId}`.replace(
        `{${"contractId"}}`,
        encodeURIComponent(String(contractId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * StoragesApi - functional programming interface
 * @export
 */
export const StoragesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StoragesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 契約IDよりストレージ情報を取得します。
     * @param {string} contractId 契約ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStoragesByContractId(
      contractId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<StorageInfoViewModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getStoragesByContractId(
          contractId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * StoragesApi - factory interface
 * @export
 */
export const StoragesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = StoragesApiFp(configuration);
  return {
    /**
     *
     * @summary 契約IDよりストレージ情報を取得します。
     * @param {string} contractId 契約ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStoragesByContractId(
      contractId: string,
      options?: any
    ): AxiosPromise<StorageInfoViewModel> {
      return localVarFp
        .getStoragesByContractId(contractId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * StoragesApi - object-oriented interface
 * @export
 * @class StoragesApi
 * @extends {BaseAPI}
 */
export class StoragesApi extends BaseAPI {
  /**
   *
   * @summary 契約IDよりストレージ情報を取得します。
   * @param {string} contractId 契約ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StoragesApi
   */
  public getStoragesByContractId(
    contractId: string,
    options?: AxiosRequestConfig
  ) {
    return StoragesApiFp(this.configuration)
      .getStoragesByContractId(contractId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary テナント情報を登録します。
     * @param {RegisterTenantInputModel} [registerTenantInputModel] テナント情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerTenant: async (
      registerTenantInputModel?: RegisterTenantInputModel,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/tenants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication api_key required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerTenantInputModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary テナント情報を登録します。
     * @param {RegisterTenantInputModel} [registerTenantInputModel] テナント情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registerTenant(
      registerTenantInputModel?: RegisterTenantInputModel,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TenantViewModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.registerTenant(
        registerTenantInputModel,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantsApiFp(configuration);
  return {
    /**
     *
     * @summary テナント情報を登録します。
     * @param {RegisterTenantInputModel} [registerTenantInputModel] テナント情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerTenant(
      registerTenantInputModel?: RegisterTenantInputModel,
      options?: any
    ): AxiosPromise<TenantViewModel> {
      return localVarFp
        .registerTenant(registerTenantInputModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
  /**
   *
   * @summary テナント情報を登録します。
   * @param {RegisterTenantInputModel} [registerTenantInputModel] テナント情報
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantsApi
   */
  public registerTenant(
    registerTenantInputModel?: RegisterTenantInputModel,
    options?: AxiosRequestConfig
  ) {
    return TenantsApiFp(this.configuration)
      .registerTenant(registerTenantInputModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
